(function () {
  'use strict';

  var sbbNamespace = window.__SBB__ = window.__SBB__ || {};
  var ScaleBarBuilder = sbbNamespace.ScaleBarBuilder;
  var clamp = sbbNamespace.clamp;
  var parseNumber = sbbNamespace.parseNumber;
  var toFixedTrim = sbbNamespace.toFixedTrim;
  var hashString = sbbNamespace.hashString;
  var nextRand = sbbNamespace.nextRand;
  var CIRCULAR_BY_VALUE = sbbNamespace.circularByValue;
  var MM_PER_CM = sbbNamespace.mmPerCm;
  var MM_PER_IN = sbbNamespace.mmPerIn;
  var DEFAULT_NOISE_GRAIN_MM = sbbNamespace.defaultNoiseGrainMm;
  var DEFAULT_NOISE_CONTRAST = sbbNamespace.defaultNoiseContrast;
  var DEFAULT_NOISE_COLOR_A = sbbNamespace.defaultNoiseColorA;
  var DEFAULT_NOISE_COLOR_B = sbbNamespace.defaultNoiseColorB;
  var ATTRIBUTION_TEXT = sbbNamespace.attributionText;
  var ATTRIBUTION_LINK = sbbNamespace.attributionLink;
  var ATTRIBUTION_PRINT_HINT = sbbNamespace.attributionPrintHint;
  var APRILTAG_QUIET_ZONE_TOTAL_FRACTION = sbbNamespace.apriltagQuietZoneTotalFraction;
  var METASHAPE_CIRCULAR_QUIET_ZONE_RADIUS_MULTIPLIER = sbbNamespace.metashapeCircularQuietZoneRadiusMultiplier;
  var METASHAPE_TEMPLATE_SETS = sbbNamespace.metashapeTemplateSets;
  var INFO_OVERLAY_DIMMED_OPACITY = sbbNamespace.infoOverlayDimmedOpacity;
  var MAX_DISTANCE_OFFSET_MM = sbbNamespace.maxDistanceOffsetMm;
  var parseOpaqueCssColor = sbbNamespace.parseOpaqueCssColor;
  var mixColors = sbbNamespace.mixColors;
  if (!ScaleBarBuilder || !clamp || !parseNumber || !toFixedTrim || !hashString || !nextRand || !CIRCULAR_BY_VALUE || !MM_PER_CM || !MM_PER_IN || !DEFAULT_NOISE_GRAIN_MM || !DEFAULT_NOISE_CONTRAST || !DEFAULT_NOISE_COLOR_A || !DEFAULT_NOISE_COLOR_B || !ATTRIBUTION_TEXT || !ATTRIBUTION_LINK || !ATTRIBUTION_PRINT_HINT || !APRILTAG_QUIET_ZONE_TOTAL_FRACTION || !METASHAPE_CIRCULAR_QUIET_ZONE_RADIUS_MULTIPLIER || !METASHAPE_TEMPLATE_SETS || !INFO_OVERLAY_DIMMED_OPACITY || !MAX_DISTANCE_OFFSET_MM || !parseOpaqueCssColor || !mixColors) {
    return;
  }

  ScaleBarBuilder.prototype.getInfoWidgetLines = function () {
    var tags = this.getActiveTags();
    var totalLengthCm = tags.length > 1 ? ((tags.length - 1) * this.state.spacingCm).toFixed(1) : '0.0';
    var preset = this.getCurrentPreset();
    return [
      'Preset: ' + preset.label + '  Type: ' + this.getTagTypeLabel(),
      'Family/Mode: ' + this.getTagFamilyLabel(),
      'Spacing: ' + this.formatDistanceMm(this.state.spacingCm * MM_PER_CM) + '  Approx bar length: ' + (this.state.unitSystem === 'imperial' ? toFixedTrim((parseFloat(totalLengthCm) * MM_PER_CM) / MM_PER_IN, 2) + ' in' : totalLengthCm + ' cm')
    ];
  };

  ScaleBarBuilder.prototype.getOverlayImageRecord = function (srcDataUrl) {
    if (!srcDataUrl) {
      return null;
    }
    if (this.imageCache.has(srcDataUrl)) {
      return this.imageCache.get(srcDataUrl);
    }

    var record = { status: 'loading', image: null };
    this.imageCache.set(srcDataUrl, record);

    var img = new Image();
    if (!/^data:/i.test(srcDataUrl)) {
      img.crossOrigin = 'anonymous';
    }
    var self = this;
    img.onload = function () {
      record.status = 'ready';
      record.image = img;
      self.render();
    };
    img.onerror = function () {
      record.status = 'missing';
      record.image = null;
      self.render();
    };
    img.src = srcDataUrl;
    return record;
  };

  ScaleBarBuilder.prototype.drawPaperBackground = function (ctx, view, paper) {
    var topLeft = this.paperToCanvas(0, 0, view);
    var paperW = paper.width * view.scale;
    var paperH = paper.height * view.scale;

    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(topLeft.x, topLeft.y, paperW, paperH);

    ctx.fillStyle = this.state.background.color || '#ffffff';
    ctx.fillRect(topLeft.x, topLeft.y, paperW, paperH);

    if (this.state.background.mode === 'image' && this.state.background.imageDataUrl) {
      var bgRecord = this.getOverlayImageRecord(this.state.background.imageDataUrl);
      if (bgRecord && bgRecord.status === 'ready' && bgRecord.image) {
        var prevAlpha = ctx.globalAlpha;
        ctx.globalAlpha = clamp(this.state.background.opacity, 0, 1);
        ctx.drawImage(bgRecord.image, topLeft.x, topLeft.y, paperW, paperH);
        ctx.globalAlpha = prevAlpha;
      }
    }

    ctx.strokeStyle = '#8a97a5';
    ctx.lineWidth = Math.max(1, 1.1 * this.pixelRatio);
    ctx.strokeRect(topLeft.x, topLeft.y, paperW, paperH);

    if (!this.isExportRender) {
      var printable = this.getPrintableRect(paper, 0);
      var p0 = this.paperToCanvas(printable.minX, printable.minY, view);
      var pw = (printable.maxX - printable.minX) * view.scale;
      var ph = (printable.maxY - printable.minY) * view.scale;
      ctx.save();
      ctx.setLineDash([Math.max(6, 1.9 * view.scale), Math.max(4, 1.3 * view.scale)]);
      ctx.strokeStyle = 'rgba(132, 145, 160, 0.35)';
      ctx.lineWidth = Math.max(1, 0.13 * view.scale);
      ctx.strokeRect(p0.x, p0.y, pw, ph);

      var marginLabel = 'Print margin';
      var labelPadPx = Math.max(4, 1.2 * this.pixelRatio);
      var labelX = p0.x + labelPadPx;
      var labelY = p0.y - labelPadPx;
      var minTopY = topLeft.y + Math.max(8, 2.2 * this.pixelRatio);
      if (labelY < minTopY) {
        labelY = p0.y + Math.max(9, 2.4 * this.pixelRatio);
      }
      ctx.setLineDash([]);
      ctx.fillStyle = 'rgba(31, 41, 51, 0.45)';
      ctx.font = this.scalePreviewPx(Math.max(8 * this.pixelRatio, 8.4)) + 'px "IBM Plex Sans", sans-serif';
      ctx.textAlign = 'left';
      ctx.textBaseline = (labelY < p0.y) ? 'bottom' : 'top';
      ctx.fillText(marginLabel, labelX, labelY);
      ctx.restore();
    }

    ctx.restore();
  };

  ScaleBarBuilder.prototype.getBackgroundNoiseTexture = function (paper) {
    this.state.backgroundNoise = this.sanitizeBackgroundNoise(this.state.backgroundNoise);
    var noise = this.state.backgroundNoise;
    var grainMm = Math.max(0.2, parseNumber(noise.grainSizeMm, DEFAULT_NOISE_GRAIN_MM));
    var cols = Math.max(1, Math.ceil(paper.width / grainMm));
    var rows = Math.max(1, Math.ceil(paper.height / grainMm));
    var maxCells = 260000;
    var estimatedCells = cols * rows;
    if (estimatedCells > maxCells) {
      var scaleUp = Math.sqrt(estimatedCells / maxCells);
      grainMm *= scaleUp;
      cols = Math.max(1, Math.ceil(paper.width / grainMm));
      rows = Math.max(1, Math.ceil(paper.height / grainMm));
    }

    var contrast = clamp(parseNumber(noise.contrast, DEFAULT_NOISE_CONTRAST), 0, 1);
    var key = [
      toFixedTrim(paper.width, 3),
      toFixedTrim(paper.height, 3),
      toFixedTrim(grainMm, 3),
      toFixedTrim(contrast, 3),
      String(noise.colorA || ''),
      String(noise.colorB || '')
    ].join('|');

    if (this.noiseTextureCache && this.noiseTextureCache.key === key && this.noiseTextureCache.canvas) {
      return this.noiseTextureCache;
    }

    var colorA = parseOpaqueCssColor(noise.colorA) || parseOpaqueCssColor(DEFAULT_NOISE_COLOR_A) || { r: 80, g: 80, b: 80, a: 1 };
    var colorB = parseOpaqueCssColor(noise.colorB) || parseOpaqueCssColor(DEFAULT_NOISE_COLOR_B) || { r: 247, g: 248, b: 250, a: 1 };
    var contrastScale = 0.2 + contrast * 1.5;
    var palette = [];
    for (var p = 0; p <= 28; p += 1) {
      var tone = p / 28;
      var mixed = mixColors(colorA, colorB, tone) || colorA;
      palette.push([
        clamp(Math.round(parseNumber(mixed.r, 0)), 0, 255),
        clamp(Math.round(parseNumber(mixed.g, 0)), 0, 255),
        clamp(Math.round(parseNumber(mixed.b, 0)), 0, 255)
      ]);
    }

    var hashNoise = function (ix, iy, seed) {
      var n = ((Math.imul(ix, 374761393) ^ Math.imul(iy, 668265263) ^ Math.imul(seed, 362437)) >>> 0);
      n = (n ^ (n >>> 13)) >>> 0;
      n = Math.imul(n, 1274126177) >>> 0;
      n = (n ^ (n >>> 16)) >>> 0;
      return n / 4294967295;
    };

    var noiseCanvas = document.createElement('canvas');
    noiseCanvas.width = cols;
    noiseCanvas.height = rows;
    var noiseCtx = noiseCanvas.getContext('2d');
    var imgData = noiseCtx.createImageData(cols, rows);
    var data = imgData.data;
    for (var y = 0; y < rows; y += 1) {
      for (var x = 0; x < cols; x += 1) {
        var coarse = hashNoise(Math.floor(x / 3), Math.floor(y / 3), 101);
        var medium = hashNoise(Math.floor(x / 2), Math.floor(y / 2), 331);
        var fine = hashNoise(x, y, 719);
        var noiseMix = coarse * 0.48 + medium * 0.26 + fine * 0.26;
        var normalized = clamp(0.5 + (noiseMix - 0.5) * contrastScale, 0, 1);
        var bucket = Math.round(normalized * 28);
        var rgb = palette[bucket];
        var di = (y * cols + x) * 4;
        data[di] = rgb[0];
        data[di + 1] = rgb[1];
        data[di + 2] = rgb[2];
        data[di + 3] = 255;
      }
    }
    noiseCtx.putImageData(imgData, 0, 0);

    this.noiseTextureCache = {
      key: key,
      canvas: noiseCanvas
    };
    return this.noiseTextureCache;
  };

  ScaleBarBuilder.prototype.drawBackgroundNoise = function (ctx, view, points, paper) {
    this.state.backgroundNoise = this.sanitizeBackgroundNoise(this.state.backgroundNoise);
    var noise = this.state.backgroundNoise;
    if (!noise.enabled) {
      return;
    }

    var vertices = this.getAutoCutOutlineVertices(points, paper);
    if (!Array.isArray(vertices) || vertices.length < 3) {
      return;
    }

    ctx.save();
    try {
      var texture = this.getBackgroundNoiseTexture(paper);
      if (!texture || !texture.canvas) {
        return;
      }
      ctx.globalAlpha = clamp(ctx.globalAlpha * (this.sceneVisualAlpha || 1), 0, 1);
      ctx.beginPath();
      var start = this.paperToCanvas(vertices[0].x, vertices[0].y, view);
      ctx.moveTo(start.x, start.y);
      for (var i = 1; i < vertices.length; i += 1) {
        var v = this.paperToCanvas(vertices[i].x, vertices[i].y, view);
        ctx.lineTo(v.x, v.y);
      }
      ctx.closePath();
      ctx.clip();

      var topLeft = this.paperToCanvas(0, 0, view);
      var paperW = paper.width * view.scale;
      var paperH = paper.height * view.scale;
      var prevSmoothing = ctx.imageSmoothingEnabled;
      ctx.imageSmoothingEnabled = false;
      ctx.drawImage(texture.canvas, topLeft.x, topLeft.y, paperW, paperH);
      ctx.imageSmoothingEnabled = prevSmoothing;
    } catch (error) {
      this.state.backgroundNoise.enabled = false;
      this.setStatus('Background noise failed to render and was disabled.', true);
      if (typeof console !== 'undefined' && console.error) {
        console.error(error);
      }
    } finally {
      ctx.restore();
    }
  };

  ScaleBarBuilder.prototype.drawCanvasRulers = function (ctx, view, paper, widthPx, heightPx) {
    if (this.isExportRender) {
      return;
    }

    var bandPx = Math.max(16, 12 * this.pixelRatio);
    var topFill = 'rgba(241, 245, 249, 0.92)';
    var lineColor = 'rgba(120, 134, 151, 0.72)';
    var textColor = 'rgba(70, 85, 102, 0.9)';
    var minorTickPx = Math.max(4, 2.8 * this.pixelRatio);
    var mediumTickPx = Math.max(7, 4.6 * this.pixelRatio);
    var majorTickPx = Math.max(10, 6.2 * this.pixelRatio);
    var fontPx = Math.max(8, 8 * this.pixelRatio);
    var mmPerPx = 1 / Math.max(0.0001, view.scale);
    var isImperial = this.state.unitSystem === 'imperial';
    var minorStepMm = isImperial ? (MM_PER_IN / 4) : 1;
    var mediumDiv = isImperial ? 2 : 5;
    var majorDiv = isImperial ? 4 : 10;
    var showMinor = (minorStepMm * view.scale) >= (isImperial ? 4.5 : 4);

    var xMinMm = (0 - view.originX) * mmPerPx;
    var xMaxMm = (widthPx - view.originX) * mmPerPx;
    var yMinMm = (0 - view.originY) * mmPerPx;
    var yMaxMm = (heightPx - view.originY) * mmPerPx;
    var xStart = Math.floor(xMinMm / minorStepMm) - 2;
    var xEnd = Math.ceil(xMaxMm / minorStepMm) + 2;
    var yStart = Math.floor(yMinMm / minorStepMm) - 2;
    var yEnd = Math.ceil(yMaxMm / minorStepMm) + 2;

    var formatMajorLabel = function (valueMm) {
      if (isImperial) {
        return toFixedTrim(valueMm / MM_PER_IN, 0) + ' in';
      }
      return toFixedTrim(valueMm / MM_PER_CM, 0) + ' cm';
    };

    ctx.save();
    ctx.fillStyle = topFill;
    ctx.fillRect(0, 0, widthPx, bandPx);
    ctx.fillRect(0, 0, bandPx, heightPx);
    ctx.fillStyle = 'rgba(226, 233, 241, 0.95)';
    ctx.fillRect(0, 0, bandPx, bandPx);

    ctx.strokeStyle = lineColor;
    ctx.lineWidth = Math.max(1, 0.95 * this.pixelRatio);
    ctx.beginPath();
    ctx.moveTo(0, bandPx + 0.5);
    ctx.lineTo(widthPx, bandPx + 0.5);
    ctx.moveTo(bandPx + 0.5, 0);
    ctx.lineTo(bandPx + 0.5, heightPx);
    ctx.stroke();

    ctx.font = fontPx + 'px "IBM Plex Sans", sans-serif';
    ctx.fillStyle = textColor;
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';

    for (var xi = xStart; xi <= xEnd; xi += 1) {
      var xMm = xi * minorStepMm;
      var xPx = view.originX + xMm * view.scale;
      if (xPx < bandPx || xPx > widthPx) {
        continue;
      }
      var xIsMajor = (xi % majorDiv) === 0;
      var xIsMedium = (xi % mediumDiv) === 0;
      if (!showMinor && !xIsMedium && !xIsMajor) {
        continue;
      }
      var xTick = xIsMajor ? majorTickPx : (xIsMedium ? mediumTickPx : minorTickPx);
      ctx.beginPath();
      ctx.moveTo(xPx, bandPx);
      ctx.lineTo(xPx, bandPx - xTick);
      ctx.stroke();
      if (xIsMajor) {
        ctx.fillText(formatMajorLabel(xMm), xPx + Math.max(2, 1.2 * this.pixelRatio), Math.max(1, 0.8 * this.pixelRatio));
      }
    }

    for (var yi = yStart; yi <= yEnd; yi += 1) {
      var yMm = yi * minorStepMm;
      var yPx = view.originY + yMm * view.scale;
      if (yPx < bandPx || yPx > heightPx) {
        continue;
      }
      var yIsMajor = (yi % majorDiv) === 0;
      var yIsMedium = (yi % mediumDiv) === 0;
      if (!showMinor && !yIsMedium && !yIsMajor) {
        continue;
      }
      var yTick = yIsMajor ? majorTickPx : (yIsMedium ? mediumTickPx : minorTickPx);
      ctx.beginPath();
      ctx.moveTo(bandPx, yPx);
      ctx.lineTo(bandPx - yTick, yPx);
      ctx.stroke();
      if (yIsMajor) {
        ctx.save();
        ctx.translate(Math.max(1, 0.6 * this.pixelRatio), yPx - Math.max(1, 0.8 * this.pixelRatio));
        ctx.rotate(-Math.PI / 2);
        ctx.fillText(formatMajorLabel(yMm), 0, 0);
        ctx.restore();
      }
    }

    ctx.restore();
  };

  ScaleBarBuilder.prototype.drawSnapGridIfActive = function (ctx, view, paper) {
    var showManualGrid = false;
    if (this.sanitizeCutShapeMode(this.state.cutShapeMode) === 'manual') {
      var cutManual = this.getCutManualState();
      showManualGrid = !!(cutManual && cutManual.showGrid && this.state.selectedEntity && this.state.selectedEntity.type === 'cut');
    }
    if (!showManualGrid && (!this.dragState || !this.state.snapEnabled)) {
      return;
    }

    var gridMinorMm = this.getGridStepMm();
    var gridMajorMm = this.getSnapGridMajorStepMm();
    var gridDivisions = this.getGridSubdivisionCount();
    var centerX = paper.width / 2;
    var centerY = paper.height / 2;

    var drawGridAtStep = function (stepMm, strokeStyle, lineWidthScale) {
      if (!Number.isFinite(stepMm) || stepMm <= 0.001) {
        return;
      }
      ctx.strokeStyle = strokeStyle;
      ctx.lineWidth = Math.max(1, lineWidthScale * view.scale);

      var xPos = centerX;
      while (xPos <= paper.width + 0.001) {
        var p1 = this.paperToCanvas(xPos, 0, view);
        var p2 = this.paperToCanvas(xPos, paper.height, view);
        ctx.beginPath();
        ctx.moveTo(p1.x, p1.y);
        ctx.lineTo(p2.x, p2.y);
        ctx.stroke();
        xPos += stepMm;
      }
      xPos = centerX - stepMm;
      while (xPos >= -0.001) {
        var p3 = this.paperToCanvas(xPos, 0, view);
        var p4 = this.paperToCanvas(xPos, paper.height, view);
        ctx.beginPath();
        ctx.moveTo(p3.x, p3.y);
        ctx.lineTo(p4.x, p4.y);
        ctx.stroke();
        xPos -= stepMm;
      }

      var yPos = centerY;
      while (yPos <= paper.height + 0.001) {
        var h1 = this.paperToCanvas(0, yPos, view);
        var h2 = this.paperToCanvas(paper.width, yPos, view);
        ctx.beginPath();
        ctx.moveTo(h1.x, h1.y);
        ctx.lineTo(h2.x, h2.y);
        ctx.stroke();
        yPos += stepMm;
      }
      yPos = centerY - stepMm;
      while (yPos >= -0.001) {
        var h3 = this.paperToCanvas(0, yPos, view);
        var h4 = this.paperToCanvas(paper.width, yPos, view);
        ctx.beginPath();
        ctx.moveTo(h3.x, h3.y);
        ctx.lineTo(h4.x, h4.y);
        ctx.stroke();
        yPos -= stepMm;
      }
    }.bind(this);

    ctx.save();
    if (gridDivisions > 1) {
      drawGridAtStep(gridMinorMm, 'rgba(25, 120, 200, 0.14)', 0.035);
      if (gridDivisions % 2 === 0) {
        drawGridAtStep(gridMajorMm / 2, 'rgba(25, 120, 200, 0.22)', 0.045);
      }
    }
    drawGridAtStep(gridMajorMm, 'rgba(25, 120, 200, 0.32)', 0.06);
    ctx.restore();
  };

  ScaleBarBuilder.prototype.getAttributionReserveMm = function () {
    return 14;
  };

  ScaleBarBuilder.prototype.drawAttribution = function (ctx, view, paper) {
    var insetMm = Math.max(4, this.getPrintMarginMm());
    var printable = this.getPrintableRect(paper, 0);
    var reserveMm = this.getAttributionReserveMm();
    var yMm = clamp(printable.maxY - reserveMm + 1.4, printable.minY, printable.maxY);
    var pos = this.paperToCanvas(insetMm, yMm, view);
    ctx.save();
    ctx.fillStyle = 'rgba(31, 41, 51, 0.7)';
    var attributionFontPx = this.isExportRender
      ? Math.max(8, 2.4 * view.scale)
      : this.scalePreviewPx(Math.max(8 * this.pixelRatio, 8.8));
    var lineStepPx = this.isExportRender ? (attributionFontPx * 1.16) : this.scalePreviewPx(Math.max(9 * this.pixelRatio, 9.4));
    ctx.font = attributionFontPx + 'px "IBM Plex Sans", sans-serif';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    ctx.fillText(ATTRIBUTION_TEXT, pos.x, pos.y);
    var firstWidth = ctx.measureText(ATTRIBUTION_TEXT).width;
    var linkText = '  ' + ATTRIBUTION_LINK;
    var rightLimitPx = this.paperToCanvas(printable.maxX, 0, view).x;
    var nextX = pos.x + firstWidth;
    var nextY = pos.y;
    if (nextX + ctx.measureText(linkText).width > rightLimitPx) {
      nextX = pos.x;
      nextY += lineStepPx;
    }
    ctx.fillStyle = 'rgba(31, 41, 51, 0.92)';
    ctx.fillText(linkText, nextX, nextY);

    var hintY = Math.max(pos.y, nextY) + lineStepPx;
    var maxHintY = this.paperToCanvas(0, printable.maxY, view).y - lineStepPx;
    hintY = Math.min(hintY, maxHintY);
    ctx.fillStyle = 'rgba(31, 41, 51, 0.62)';
    ctx.fillText(ATTRIBUTION_PRINT_HINT, pos.x, hintY);
    ctx.restore();
  };

  ScaleBarBuilder.prototype.tryGetCachedTagImage = function (tagId) {
    if (this.state.tagType !== 'apriltag') {
      return null;
    }

    var key = this.state.tagType + ':' + this.state.tagFamily + ':' + tagId;
    if (this.tagImageCache.has(key)) {
      return this.tagImageCache.get(key);
    }

    var record = { status: 'loading', image: null };
    this.tagImageCache.set(key, record);

    var img = new Image();
    var self = this;
    img.onload = function () {
      record.status = 'ready';
      record.image = img;
      self.render();
    };
    img.onerror = function () {
      record.status = 'missing';
      record.image = null;
      self.render();
    };

    img.src = this.getTagAssetBase() + '/' + this.state.tagFamily + '/' + tagId + '.svg';
    return record;
  };

  ScaleBarBuilder.prototype.drawGeneratedAprilTag = function (ctx, x, y, size, tagId) {
    var matrix = this.getGeneratedAprilTagMatrix(tagId);
    var totalModules = matrix.length;
    var left = Math.round(x);
    var top = Math.round(y);
    var right = Math.round(x + size);
    var bottom = Math.round(y + size);
    var drawW = Math.max(totalModules, right - left);
    var drawH = Math.max(totalModules, bottom - top);

    var xEdges = [];
    var yEdges = [];
    for (var i = 0; i <= totalModules; i += 1) {
      xEdges.push(left + Math.round((drawW * i) / totalModules));
      yEdges.push(top + Math.round((drawH * i) / totalModules));
    }

    ctx.fillStyle = '#fff';
    ctx.fillRect(left, top, drawW, drawH);
    ctx.fillStyle = '#000';
    for (var row = 0; row < totalModules; row += 1) {
      for (var col = 0; col < totalModules; col += 1) {
        if (!matrix[row] || !matrix[row][col]) {
          continue;
        }
        var x0 = xEdges[col];
        var x1 = xEdges[col + 1];
        var y0 = yEdges[row];
        var y1 = yEdges[row + 1];
        if (x1 <= x0 || y1 <= y0) {
          continue;
        }
        ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
      }
    }
  };

  ScaleBarBuilder.prototype.bitwiseRotateLeft = function (value, bits, totalBits) {
    var mask = (1 << totalBits) - 1;
    return (((value << bits) & mask) | ((value & mask) >>> (totalBits - bits))) >>> 0;
  };

  ScaleBarBuilder.prototype.findSmallestRotation = function (value, totalBits) {
    var smallest = value >>> 0;
    for (var i = 1; i < totalBits; i += 1) {
      var rotated = this.bitwiseRotateLeft(value, i, totalBits);
      if (rotated < smallest) {
        smallest = rotated;
      }
    }
    return smallest >>> 0;
  };

  ScaleBarBuilder.prototype.hasEvenParity = function (value) {
    var parity = true;
    var v = value >>> 0;
    while (v) {
      parity = !parity;
      v &= (v - 1);
    }
    return parity;
  };

  ScaleBarBuilder.prototype.popcount = function (value) {
    var v = value >>> 0;
    var count = 0;
    while (v) {
      v &= (v - 1);
      count += 1;
    }
    return count;
  };

  ScaleBarBuilder.prototype.maxConsecutiveZerosCircular = function (value, totalBits) {
    var bitStr = (value >>> 0).toString(2);
    while (bitStr.length < totalBits) {
      bitStr = '0' + bitStr;
    }
    var doubled = bitStr + bitStr;
    var maxZ = 0;
    var cur = 0;
    for (var i = 0; i < doubled.length; i += 1) {
      if (doubled.charAt(i) === '0') {
        cur += 1;
        if (cur > maxZ) {
          maxZ = cur;
        }
      } else {
        cur = 0;
      }
    }
    return Math.min(maxZ, totalBits);
  };

  ScaleBarBuilder.prototype.generateMetashapeCodes = function (bits) {
    var totalBits = Math.max(2, Math.round(parseNumber(bits, 14)));
    var maxZeros = Math.floor(totalBits / 2) - 1;
    var codeCount = 1 << (totalBits - 2);
    var codes = [];
    var seen = {};
    for (var i = 0; i < codeCount; i += 1) {
      var code = ((i << 1) + 1) >>> 0;
      code = this.findSmallestRotation(code, totalBits);
      if (seen[code]) {
        continue;
      }
      if (!this.hasEvenParity(code)) {
        continue;
      }
      if (this.popcount(code) < 4) {
        continue;
      }
      if (this.maxConsecutiveZerosCircular(code, totalBits) > maxZeros) {
        continue;
      }
      seen[code] = true;
      codes.push(code);
    }
    return codes;
  };

  ScaleBarBuilder.prototype.getMetashapeCodesForFamily = function (family) {
    var spec = METASHAPE_TEMPLATE_SETS[family];
    if (!spec) {
      return null;
    }
    if (Array.isArray(this.metashapeCodesCache[family]) && this.metashapeCodesCache[family].length) {
      return this.metashapeCodesCache[family];
    }
    try {
      var generated = this.generateMetashapeCodes(spec.bits);
      if (generated && generated.length) {
        this.metashapeCodesCache[family] = generated;
        return generated;
      }
    } catch (error) {
      return null;
    }
    return null;
  };

  ScaleBarBuilder.prototype.drawGeneratedMetashapeCircularTag = function (ctx, cx, cy, radius, tagId) {
    var family = this.state.tagFamily;
    var spec = METASHAPE_TEMPLATE_SETS[family];
    if (!spec) {
      return false;
    }
    var codes = this.getMetashapeCodesForFamily(family);
    if (!codes || !codes.length) {
      return false;
    }
    var index = ((Math.round(tagId) % codes.length) + codes.length) % codes.length;
    var code = codes[index] >>> 0;
    var bits = spec.bits;

    var targetR = radius * 0.88;
    var dotR = targetR / 3;
    var ringCenterR = dotR * 2.5;
    var ringThickness = dotR;
    var ringOuterR = ringCenterR + ringThickness / 2;
    var ringInnerR = Math.max(0.1, ringCenterR - ringThickness / 2);

    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(cx, cy, targetR, 0, Math.PI * 2);
    ctx.fill();

    ctx.fillStyle = '#000000';
    for (var i = 0; i < bits; i += 1) {
      if (!((1 << (bits - 1 - i)) & code)) {
        continue;
      }
      var start = (Math.PI * 2 * i) / bits;
      var end = (Math.PI * 2 * (i + 1)) / bits;
      ctx.beginPath();
      ctx.arc(cx, cy, ringOuterR, start, end, false);
      ctx.arc(cx, cy, ringInnerR, end, start, true);
      ctx.closePath();
      ctx.fill();
    }

    ctx.beginPath();
    ctx.arc(cx, cy, dotR, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(cx, cy, dotR * 0.07, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#000000';
    ctx.beginPath();
    ctx.arc(cx, cy, dotR * 0.0175, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
    return true;
  };

  ScaleBarBuilder.prototype.drawGeneratedCircularTag = function (ctx, cx, cy, radius, tagId) {
    if (this.state.tagFamily && this.state.tagFamily.indexOf('metashape-') === 0) {
      if (this.drawGeneratedMetashapeCircularTag(ctx, cx, cy, radius, tagId)) {
        return;
      }
    }
    var circleConfig = CIRCULAR_BY_VALUE[this.state.tagFamily] || { segments: 16, ringMode: 'single', polarity: 'normal' };
    var resolvedCode = this.resolveRealityScanCircularCode(tagId, this.state.tagFamily);
    if (resolvedCode) {
      circleConfig = {
        segments: Math.max(1, Math.round(parseNumber(resolvedCode.segments, circleConfig.segments || 16))),
        ringMode: resolvedCode.ringMode === 'dual' ? 'dual' : 'single',
        polarity: circleConfig.polarity
      };
    }
    var isInverted = circleConfig.polarity === 'inverted';
    var dark = isInverted ? '#fff' : '#000';
    var light = isInverted ? '#000' : '#fff';
    var segments = Math.max(1, Math.round(parseNumber(circleConfig.segments, 16)));
    var backgroundR = radius * 0.98;
    var codeOuterR = radius * 0.86;
    var codeInnerR = radius * 0.56;
    var separatorR = radius * 0.44;
    var centerR = radius * 0.22;
    var outerCodeBits = '';
    var innerCodeBits = '';
    if (resolvedCode && resolvedCode.code) {
      var codeParts = String(resolvedCode.code).split('|');
      outerCodeBits = String(codeParts[0] || '').trim();
      innerCodeBits = codeParts.length > 1 ? String(codeParts[1] || '').trim() : '';
    }
    var useOuterCode = outerCodeBits.length >= segments;
    var useInnerCode = innerCodeBits.length >= segments;

    ctx.fillStyle = light;
    ctx.beginPath();
    ctx.arc(cx, cy, backgroundR, 0, Math.PI * 2);
    ctx.fill();

    var seed = { value: hashString(this.state.tagFamily + ':' + tagId + ':c') };
    for (var i = 0; i < segments; i += 1) {
      var start = (Math.PI * 2 * i) / segments;
      var end = (Math.PI * 2 * (i + 1)) / segments;
      var on = useOuterCode
        ? outerCodeBits.charAt(i % outerCodeBits.length) === '1'
        : (nextRand(seed) > 0.5);

      ctx.beginPath();
      ctx.arc(cx, cy, codeOuterR, start, end, false);
      ctx.arc(cx, cy, codeInnerR, end, start, true);
      ctx.closePath();
      ctx.fillStyle = on ? dark : light;
      ctx.fill();
    }

    ctx.fillStyle = light;
    ctx.beginPath();
    ctx.arc(cx, cy, separatorR, 0, Math.PI * 2);
    ctx.fill();

    if (circleConfig.ringMode === 'dual') {
      var innerSeed = { value: hashString(this.state.tagFamily + ':' + tagId + ':inner') };
      var innerOuterR = radius * 0.42;
      var innerInnerR = radius * 0.30;
      for (var j = 0; j < segments; j += 1) {
        var innerStart = (Math.PI * 2 * j) / segments;
        var innerEnd = (Math.PI * 2 * (j + 1)) / segments;
        var innerOn = useInnerCode
          ? innerCodeBits.charAt(j % innerCodeBits.length) === '1'
          : (nextRand(innerSeed) > 0.5);

        ctx.beginPath();
        ctx.arc(cx, cy, innerOuterR, innerStart, innerEnd, false);
        ctx.arc(cx, cy, innerInnerR, innerEnd, innerStart, true);
        ctx.closePath();
        ctx.fillStyle = innerOn ? dark : light;
        ctx.fill();
      }
    }

    ctx.fillStyle = dark;
    ctx.beginPath();
    ctx.arc(cx, cy, centerR, 0, Math.PI * 2);
    ctx.fill();

    if (this.shouldDrawCircularCenterMarker(this.state.tagFamily)) {
      this.drawCircularCenterMarker(ctx, cx, cy, radius);
    }
  };

  ScaleBarBuilder.prototype.shouldDrawCircularCenterMarker = function (tagFamily) {
    var family = typeof tagFamily === 'string' ? tagFamily : (this.state && this.state.tagFamily ? this.state.tagFamily : '');
    return family.indexOf('metashape-') !== 0;
  };

  ScaleBarBuilder.prototype.drawCircularCenterMarker = function (ctx, cx, cy, radius) {
    var whiteBaseR = Math.max(0.6, radius * 0.065);
    var dotBaseR = Math.max(0.3, whiteBaseR * 0.48);
    var whiteR = whiteBaseR * 0.7;
    var dotR = dotBaseR * 0.3;

    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(cx, cy, whiteR, 0, Math.PI * 2);
    ctx.fill();

    ctx.fillStyle = '#000000';
    ctx.beginPath();
    ctx.arc(cx, cy, dotR, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  };

  ScaleBarBuilder.prototype.getReferenceById = function (id) {
    if (!Array.isArray(this.state.references)) {
      return null;
    }
    for (var i = 0; i < this.state.references.length; i += 1) {
      if (this.state.references[i].id === id) {
        return this.state.references[i];
      }
    }
    return null;
  };

  ScaleBarBuilder.prototype.getReferenceMaxLengthMm = function (centerX, a, b, paper) {
    var dx = b.x - a.x;
    var dy = b.y - a.y;
    var distMm = Math.sqrt(dx * dx + dy * dy);
    var keepoutFromCenterMm = this.getTagCenterKeepoutMm();
    var maxLenFromCentersMm = distMm - 2 * keepoutFromCenterMm;
    var printable = this.getPrintableRect(paper, 0);
    var maxLenFromPaperMm = 2 * Math.min(centerX - printable.minX - 1, printable.maxX - centerX - 1);
    return Math.max(0, Math.min(maxLenFromCentersMm, maxLenFromPaperMm));
  };

  ScaleBarBuilder.prototype.ensureDefaultReferenceBar = function (points, paper) {
    if (!Array.isArray(this.state.references)) {
      this.state.references = [];
    }
    if (this.state.references.length > 0 || points.length < 2) {
      return;
    }

    var outline = this.getAutoCutOutlineVertices(points, paper);
    if (outline.length < 2) {
      return;
    }

    var topEdgeY = Infinity;
    for (var i = 0; i < outline.length; i += 1) {
      topEdgeY = Math.min(topEdgeY, outline[i].y);
    }

    var a = points[0];
    var b = points[1];
    var centerX = (a.x + b.x) / 2;
    var cellWidthMm = this.state.checkerWidthCm * MM_PER_CM;
    var cellHeightMm = this.state.checkerHeightMm;
    var insetMm = clamp(this.state.cutMarginCm * MM_PER_CM * 0.25, 1, 6);
    var printable = this.getPrintableRect(paper, 0);
    var y = clamp(topEdgeY + insetMm, printable.minY, printable.maxY - cellHeightMm - 0.5);
    var maxLenMm = this.getReferenceMaxLengthMm(centerX, a, b, paper);
    if (maxLenMm < cellWidthMm) {
      maxLenMm = cellWidthMm;
    }

    var fullCells = Math.max(1, Math.floor(maxLenMm / cellWidthMm));
    var lengthMm = clamp(fullCells * cellWidthMm, cellWidthMm, maxLenMm);
    var leftX = clamp(centerX - lengthMm / 2, printable.minX, printable.maxX - lengthMm);

    this.state.references.push({
      id: 'ref-' + this.referenceCounter,
      xMm: leftX,
      yMm: y,
      lengthMm: lengthMm,
      cellWidthMm: cellWidthMm,
      cellHeightMm: cellHeightMm,
      rows: 1,
      rotationDeg: 0,
      style: 'checker',
      colorA: '#000000',
      colorB: '#ffffff',
      labelColor: '#000000',
      visible: true,
      showLabel: true,
      showScaleNumbers: false,
      unitSystem: this.state.unitSystem === 'imperial' ? 'imperial' : 'metric',
      showUnitLabelInside: false
    });
    this.referenceCounter += 1;
  };

  ScaleBarBuilder.prototype.addReferenceBar = function () {
    var paper = this.getPaper();
    var points = this.getCurrentPoints();
    this.ensureDefaultReferenceBar(points, paper);

    var cellWidthMm = this.state.checkerWidthCm * MM_PER_CM;
    var cellHeightMm = this.state.checkerHeightMm;
    var base = this.state.references[0];
    var x = base ? base.xMm : (paper.width - cellWidthMm * 6) / 2;
    var y = base ? base.yMm + this.state.references.length * (cellHeightMm + 4) : paper.height * 0.25;
    var lengthMm = base ? base.lengthMm : cellWidthMm * 6;
    var printable = this.getPrintableRect(paper, 0);

    lengthMm = clamp(lengthMm, cellWidthMm, Math.max(cellWidthMm, printable.maxX - printable.minX - 2));
    x = clamp(x, printable.minX, printable.maxX - lengthMm);
    y = clamp(y, printable.minY, printable.maxY - cellHeightMm - 2);
    x = this.snapCenterToGrid(x, this.getGridStepMm(), paper.width / 2);
    y = this.snapCenterToGrid(y, this.getGridStepMm(), paper.height / 2);

    var ref = {
      id: 'ref-' + this.referenceCounter,
      xMm: x,
      yMm: y,
      lengthMm: lengthMm,
      cellWidthMm: cellWidthMm,
      cellHeightMm: cellHeightMm,
      rows: 1,
      rotationDeg: 0,
      style: 'checker',
      colorA: '#000000',
      colorB: '#ffffff',
      labelColor: '#000000',
      visible: true,
      showLabel: true,
      showScaleNumbers: false,
      unitSystem: this.state.unitSystem === 'imperial' ? 'imperial' : 'metric',
      showUnitLabelInside: false
    };
    this.referenceCounter += 1;
    this.state.references.push(ref);
    this.state.selectedEntity = { type: 'reference', id: ref.id };
    this.render();
    this.commitHistory();
  };

  ScaleBarBuilder.prototype.drawSingleReferenceBar = function (ctx, view, ref) {
    if (!ref) {
      return;
    }

    var xMm = ref.xMm;
    var yMm = ref.yMm;
    var lengthMm = Math.max(ref.cellWidthMm || 1, ref.lengthMm || 1);
    var cellWidthMm = Math.max(0.2, ref.cellWidthMm || (this.state.checkerWidthCm * MM_PER_CM));
    var cellHeightMm = Math.max(0.2, ref.cellHeightMm || this.state.checkerHeightMm);
    var rows = Math.max(1, Math.round(ref.rows || 1));
    var totalHeightMm = rows * cellHeightMm;
    var cells = Math.max(1, Math.round(lengthMm / cellWidthMm));
    lengthMm = cells * cellWidthMm;
    ref.lengthMm = lengthMm;
    ref.rows = rows;
    ref.rotationDeg = this.normalizeRotation(ref.rotationDeg || 0);

    var centerXmm = xMm + lengthMm / 2;
    var centerYmm = yMm + totalHeightMm / 2;
    var centerPx = this.paperToCanvas(centerXmm, centerYmm, view);

    ctx.save();
    ctx.translate(centerPx.x, centerPx.y);
    ctx.rotate((ref.rotationDeg * Math.PI) / 180);

    var style = ref.style || 'checker';
    if (style === 'solid-dark' || style === 'solid-light') {
      style = 'checker';
    }
    ref.style = style;
    var refUnitSystem = this.getReferenceUnitSystem(ref);
    ref.unitSystem = refUnitSystem;
    ref.showUnitLabelInside = !!ref.showUnitLabelInside;
    var i;
    var row;

    ctx.fillStyle = ref.colorB || '#ffffff';
    ctx.fillRect(
      (-lengthMm / 2) * view.scale,
      (-totalHeightMm / 2) * view.scale,
      lengthMm * view.scale,
      totalHeightMm * view.scale
    );

    if (style === 'checker' || style === 'checker-invert') {
      var checkerInverted = style === 'checker-invert';
      var isLightCheckerCell = function (col, rowIndex) {
        var parityEven = ((col + rowIndex) % 2) === 0;
        return checkerInverted ? parityEven : !parityEven;
      };
      for (row = 0; row < rows; row += 1) {
        for (i = 0; i < cells; i += 1) {
          var checkerColor = (i + row) % 2 === 0 ? (ref.colorA || '#000000') : (ref.colorB || '#ffffff');
          if (checkerInverted) {
            checkerColor = (i + row) % 2 === 0 ? (ref.colorB || '#ffffff') : (ref.colorA || '#000000');
          }
          ctx.fillStyle = checkerColor;
          ctx.fillRect(
            (-lengthMm / 2 + i * cellWidthMm) * view.scale,
            (-totalHeightMm / 2 + row * cellHeightMm) * view.scale,
            cellWidthMm * view.scale,
            cellHeightMm * view.scale
          );
        }
      }

      // Marker text for one reference unit (cm/in) inside the first checker square.
      var firstCellCenterXmm = -lengthMm / 2 + cellWidthMm / 2;
      var firstCellCenterYmm = -totalHeightMm / 2 + cellHeightMm / 2;
      var firstCellIsLight = isLightCheckerCell(0, 0);
      var unitMarker = this.formatReferenceAxisUnitLabel(cellWidthMm, refUnitSystem, {
        compact: true,
        useImperialWord: true,
        omitOneForMm: true
      });
      ctx.save();
      var unitMarkerFontPx = this.isExportRender
        ? Math.max(5.2, Math.min(cellWidthMm, cellHeightMm) * view.scale * 0.34)
        : Math.max(
          this.scalePreviewPx(Math.max(6 * this.pixelRatio, 6.4)),
          Math.min(cellWidthMm, cellHeightMm) * view.scale * 0.3
        );
      ctx.font = '700 ' + unitMarkerFontPx + 'px "IBM Plex Mono", monospace';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = firstCellIsLight ? 'rgba(31, 41, 51, 0.88)' : 'rgba(255, 255, 255, 0.94)';
      ctx.fillText(unitMarker, firstCellCenterXmm * view.scale, firstCellCenterYmm * view.scale);
      ctx.restore();

      // Corner plus markers to reveal terminal white checker bounds against the white page.
      var findBottomMostLightRow = function (colIndex) {
        for (var rr = rows - 1; rr >= 0; rr -= 1) {
          if (isLightCheckerCell(colIndex, rr)) {
            return rr;
          }
        }
        return -1;
      };
      var leftPlusRow = findBottomMostLightRow(0);
      var rightPlusRow = findBottomMostLightRow(cells - 1);
      var plusHalfPx = clamp(Math.min(cellWidthMm, cellHeightMm) * view.scale * 0.12, 1.6, 5.4);
      var plusStrokePx = Math.max(1, 0.09 * view.scale);
      var drawCornerPlus = function (cxPx, cyPx) {
        ctx.beginPath();
        ctx.moveTo(cxPx - plusHalfPx, cyPx);
        ctx.lineTo(cxPx + plusHalfPx, cyPx);
        ctx.moveTo(cxPx, cyPx - plusHalfPx);
        ctx.lineTo(cxPx, cyPx + plusHalfPx);
        ctx.stroke();
      };
      ctx.save();
      ctx.strokeStyle = 'rgba(31, 41, 51, 0.82)';
      ctx.lineWidth = plusStrokePx;
      ctx.lineCap = 'round';
      if (leftPlusRow >= 0) {
        drawCornerPlus(
          (-lengthMm / 2) * view.scale,
          (-totalHeightMm / 2 + (leftPlusRow + 1) * cellHeightMm) * view.scale
        );
      }
      if (rightPlusRow >= 0) {
        drawCornerPlus(
          (lengthMm / 2) * view.scale,
          (-totalHeightMm / 2 + (rightPlusRow + 1) * cellHeightMm) * view.scale
        );
      }
      ctx.restore();
    } else if (style === 'segmented-blocks') {
      var bandHeightMm = totalHeightMm * 0.58;
      var bandYmm = -bandHeightMm / 2;
      for (i = 0; i < cells; i += 1) {
        ctx.fillStyle = i % 2 === 0 ? (ref.colorA || '#000000') : (ref.colorB || '#ffffff');
        ctx.fillRect(
          (-lengthMm / 2 + i * cellWidthMm) * view.scale,
          bandYmm * view.scale,
          cellWidthMm * view.scale,
          bandHeightMm * view.scale
        );
      }
    } else {
      var subdivCount = this.getReferenceSubdivisionCount(cellWidthMm, refUnitSystem);
      var majorColor = ref.colorA || '#000000';
      var topYmm = -totalHeightMm / 2;
      var bottomYmm = totalHeightMm / 2;
      var midYmm = 0;
      var minorHalfMm = Math.max(totalHeightMm * 0.18, 0.5);

      ctx.strokeStyle = majorColor;
      if (style === 'segmented-ticks') {
        ctx.lineWidth = Math.max(1, 0.11 * view.scale);
        ctx.beginPath();
        ctx.moveTo((-lengthMm / 2) * view.scale, topYmm * view.scale);
        ctx.lineTo((lengthMm / 2) * view.scale, topYmm * view.scale);
        ctx.moveTo((-lengthMm / 2) * view.scale, bottomYmm * view.scale);
        ctx.lineTo((lengthMm / 2) * view.scale, bottomYmm * view.scale);
        ctx.stroke();
      } else {
        ctx.lineWidth = Math.max(1.1, 0.14 * view.scale);
        ctx.beginPath();
        ctx.moveTo((-lengthMm / 2) * view.scale, midYmm * view.scale);
        ctx.lineTo((lengthMm / 2) * view.scale, midYmm * view.scale);
        ctx.stroke();
      }

      for (i = 0; i <= cells; i += 1) {
        var unitXmm = -lengthMm / 2 + i * cellWidthMm;
        ctx.lineWidth = Math.max(1.2, 0.16 * view.scale);
        ctx.beginPath();
        ctx.moveTo(unitXmm * view.scale, topYmm * view.scale);
        ctx.lineTo(unitXmm * view.scale, bottomYmm * view.scale);
        ctx.stroke();

        if (i >= cells) {
          continue;
        }
        for (var sub = 1; sub < subdivCount; sub += 1) {
          var subXmm = unitXmm + (sub * cellWidthMm) / subdivCount;
          ctx.lineWidth = Math.max(1, 0.1 * view.scale);
          ctx.beginPath();
          if (style === 'segmented-ticks') {
            ctx.moveTo(subXmm * view.scale, midYmm * view.scale);
            ctx.lineTo(subXmm * view.scale, bottomYmm * view.scale);
          } else {
            ctx.moveTo(subXmm * view.scale, (-minorHalfMm) * view.scale);
            ctx.lineTo(subXmm * view.scale, minorHalfMm * view.scale);
          }
          ctx.stroke();
        }
      }

      if (ref.showScaleNumbers && (style === 'segmented-dashed' || style === 'segmented-ticks')) {
        var maxLabels = 14;
        var labelStep = Math.max(1, Math.ceil(cells / maxLabels));
        var labelYmm = topYmm - Math.max(0.7, totalHeightMm * 0.14);
        var suffix = ' ' + this.getReferenceUnitLabel(refUnitSystem, false);
        var drawnLast = -1;
        ctx.save();
        var scaleNumberFontPx = this.isExportRender
          ? Math.max(6, 1.9 * view.scale)
          : this.scalePreviewPx(Math.max(8 * this.pixelRatio, 8.5));
        ctx.font = scaleNumberFontPx + 'px "IBM Plex Mono", monospace';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        ctx.fillStyle = 'rgba(31, 41, 51, 0.82)';
        var drawScaleLabelWithBg = function (labelText, xPx, yPx) {
          var metrics = ctx.measureText(labelText);
          var textW = metrics.width;
          var ascent = Math.max(1, parseNumber(metrics.actualBoundingBoxAscent, scaleNumberFontPx * 0.78));
          var descent = Math.max(1, parseNumber(metrics.actualBoundingBoxDescent, scaleNumberFontPx * 0.25));
          var padX = Math.max(1.4, 0.5 * view.scale);
          var padY = Math.max(1.1, 0.34 * view.scale);
          var boxX = xPx - textW / 2 - padX;
          var boxY = yPx - ascent - padY;
          var boxW = textW + padX * 2;
          var boxH = ascent + descent + padY * 2;
          ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
          ctx.fillRect(boxX, boxY, boxW, boxH);
          ctx.fillStyle = 'rgba(31, 41, 51, 0.84)';
          ctx.fillText(labelText, xPx, yPx);
        };
        for (i = 0; i <= cells; i += labelStep) {
          var valueLabel = this.formatReferenceScaleValue(i * cellWidthMm, refUnitSystem);
          if (i === cells) {
            valueLabel += suffix;
          }
          var labelXmm = -lengthMm / 2 + i * cellWidthMm;
          drawScaleLabelWithBg(valueLabel, labelXmm * view.scale, labelYmm * view.scale);
          drawnLast = i;
        }
        if (drawnLast !== cells) {
          var finalLabel = this.formatReferenceScaleValue(cells * cellWidthMm, refUnitSystem) + suffix;
          var finalXmm = -lengthMm / 2 + cells * cellWidthMm;
          drawScaleLabelWithBg(finalLabel, finalXmm * view.scale, labelYmm * view.scale);
        }
        ctx.restore();
      }
    }

    if (ref.showUnitLabelInside) {
      var unitText = this.formatReferenceAxisUnitLabel(cellWidthMm, refUnitSystem, {
        compact: false,
        useImperialWord: true,
        upperCaseUnit: true,
        omitOneForMm: true
      });
      ctx.save();
      var unitFontPx = this.isExportRender
        ? Math.max(6, Math.min(12, totalHeightMm * view.scale * 0.56))
        : Math.max(this.scalePreviewPx(Math.max(7 * this.pixelRatio, 7.5)), Math.min(13, totalHeightMm * view.scale * 0.6));
      ctx.font = '700 ' + unitFontPx + 'px "IBM Plex Mono", monospace';
      var unitMetrics = ctx.measureText(unitText);
      var unitPadXPx = Math.max(2, 0.65 * view.scale);
      var unitPadYPx = Math.max(1.5, 0.45 * view.scale);
      var unitBoxWpx = unitMetrics.width + unitPadXPx * 2;
      var unitBoxHpx = unitFontPx * 1.22 + unitPadYPx * 2;
      var maxBoxWpx = Math.max(12, lengthMm * view.scale * 0.32);
      unitBoxWpx = Math.min(unitBoxWpx, maxBoxWpx);
      var unitCenterY = 0;
      ctx.fillStyle = 'rgba(255, 255, 255, 0.92)';
      ctx.strokeStyle = 'rgba(31, 41, 51, 0.46)';
      ctx.lineWidth = Math.max(1, 0.08 * view.scale);
      ctx.fillRect(-unitBoxWpx / 2, unitCenterY - unitBoxHpx / 2, unitBoxWpx, unitBoxHpx);
      ctx.strokeRect(-unitBoxWpx / 2, unitCenterY - unitBoxHpx / 2, unitBoxWpx, unitBoxHpx);
      ctx.fillStyle = 'rgba(20, 20, 20, 0.9)';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(unitText, 0, unitCenterY);
      ctx.restore();
    }

    ctx.restore();

    if (ref.showLabel !== false) {
      var labelGapMm = 1.2;
      var labelAnchor = this.rotatePoint(
        centerXmm,
        centerYmm + totalHeightMm / 2 + labelGapMm,
        centerXmm,
        centerYmm,
        ref.rotationDeg
      );
      var labelPos = this.paperToCanvas(labelAnchor.x, labelAnchor.y, view);
      ctx.save();
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';
      var refLabelFontPx = this.isExportRender
        ? Math.max(8, 2.5 * view.scale)
        : this.scalePreviewPx(Math.max(9 * this.pixelRatio, 10));
      var refLabelText = this.formatReferenceDistance(lengthMm, refUnitSystem);
      ctx.font = refLabelFontPx + 'px "IBM Plex Mono", monospace';
      ctx.translate(labelPos.x, labelPos.y);
      ctx.rotate((ref.rotationDeg * Math.PI) / 180);
      var refLabelMetrics = ctx.measureText(refLabelText);
      var refLabelPadXPx = Math.max(2, 0.55 * view.scale);
      var refLabelPadYPx = Math.max(1.4, 0.4 * view.scale);
      var refLabelBoxWpx = refLabelMetrics.width + refLabelPadXPx * 2;
      var refLabelBoxHpx = refLabelFontPx * 1.2 + refLabelPadYPx * 2;
      ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
      ctx.strokeStyle = 'rgba(31, 41, 51, 0.32)';
      ctx.lineWidth = Math.max(1, 0.07 * view.scale);
      ctx.fillRect(-refLabelBoxWpx / 2, -refLabelPadYPx, refLabelBoxWpx, refLabelBoxHpx);
      ctx.strokeRect(-refLabelBoxWpx / 2, -refLabelPadYPx, refLabelBoxWpx, refLabelBoxHpx);
      ctx.fillStyle = ref.labelColor || '#000000';
      ctx.fillText(refLabelText, 0, 0);
      ctx.restore();
    }

    if (this.state.showReferenceMeasurements) {
      var measurementGapMm = (ref.showLabel !== false) ? 4.1 : 1.6;
      var measurementAnchor = this.rotatePoint(
        centerXmm,
        centerYmm + totalHeightMm / 2 + measurementGapMm,
        centerXmm,
        centerYmm,
        ref.rotationDeg
      );
      var measurementPos = this.paperToCanvas(measurementAnchor.x, measurementAnchor.y, view);
      var measurementText = this.formatReferenceMeasurementText(cellWidthMm, cellHeightMm, refUnitSystem);
      ctx.save();
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';
      var measurementFontPx = this.isExportRender
        ? Math.max(7, 2.1 * view.scale)
        : this.scalePreviewPx(Math.max(8 * this.pixelRatio, 8.6));
      ctx.font = measurementFontPx + 'px "IBM Plex Mono", monospace';
      ctx.translate(measurementPos.x, measurementPos.y);
      ctx.rotate((ref.rotationDeg * Math.PI) / 180);
      var measurementMetrics = ctx.measureText(measurementText);
      var measurementPadXPx = Math.max(1.8, 0.5 * view.scale);
      var measurementPadYPx = Math.max(1.2, 0.34 * view.scale);
      var measurementBoxWpx = measurementMetrics.width + measurementPadXPx * 2;
      var measurementBoxHpx = measurementFontPx * 1.18 + measurementPadYPx * 2;
      ctx.fillStyle = 'rgba(255, 255, 255, 0.88)';
      ctx.strokeStyle = 'rgba(31, 41, 51, 0.28)';
      ctx.lineWidth = Math.max(1, 0.06 * view.scale);
      ctx.fillRect(-measurementBoxWpx / 2, -measurementPadYPx, measurementBoxWpx, measurementBoxHpx);
      ctx.strokeRect(-measurementBoxWpx / 2, -measurementPadYPx, measurementBoxWpx, measurementBoxHpx);
      ctx.fillStyle = 'rgba(31, 41, 51, 0.78)';
      ctx.fillText(measurementText, 0, 0);
      ctx.restore();
    }

    var aabb = this.getRotatedRectAabb(xMm, yMm, lengthMm, totalHeightMm, ref.rotationDeg);
    var refPoly = [
      { x: aabb.corners.tl.x, y: aabb.corners.tl.y },
      { x: aabb.corners.tr.x, y: aabb.corners.tr.y },
      { x: aabb.corners.br.x, y: aabb.corners.br.y },
      { x: aabb.corners.bl.x, y: aabb.corners.bl.y }
    ];
    ref._computedXmm = xMm;
    ref._computedYmm = yMm;
    ref._computedWmm = lengthMm;
    ref._computedHmm = totalHeightMm;
    this.hitRegions.push({
      kind: 'reference',
      id: ref.id,
      xMm: aabb.x,
      yMm: aabb.y,
      wMm: Math.max(2, aabb.w),
      hMm: Math.max(2, aabb.h),
      hitTest: 'rotated-rect',
      vertices: refPoly,
      z: 78
    });
  };

  ScaleBarBuilder.prototype.drawReferenceBars = function (ctx, view, paper, points) {
    if (!this.state.showGrid) {
      return;
    }

    this.ensureDefaultReferenceBar(points, paper);
    if (!Array.isArray(this.state.references)) {
      return;
    }

    var printable = this.getPrintableRect(paper, 0);
    var printableWidth = Math.max(0.2, printable.maxX - printable.minX);
    var printableHeight = Math.max(0.2, printable.maxY - printable.minY);
    ctx.save();
    ctx.globalAlpha = clamp(ctx.globalAlpha * (this.sceneVisualAlpha || 1), 0, 1);
    for (var i = 0; i < this.state.references.length; i += 1) {
      var ref = this.state.references[i];
      ref.visible = ref.visible !== false;
      if (!ref.visible) {
        continue;
      }
      ref.unitSystem = this.getReferenceUnitSystem(ref);
      ref.showUnitLabelInside = !!ref.showUnitLabelInside;
      ref.cellWidthMm = clamp(ref.cellWidthMm || (this.state.checkerWidthCm * MM_PER_CM), 0.2, printableWidth);
      ref.rows = Math.max(1, Math.round(ref.rows || 1));
      ref.cellHeightMm = clamp(ref.cellHeightMm || this.state.checkerHeightMm, 0.2, printableHeight / ref.rows);
      ref.rows = clamp(ref.rows, 1, Math.max(1, Math.floor(printableHeight / Math.max(0.2, ref.cellHeightMm))));
      ref.lengthMm = clamp(ref.lengthMm || ref.cellWidthMm * 6, ref.cellWidthMm, printableWidth);
      var refTotalHeight = ref.cellHeightMm * ref.rows;
      if (!this.state.cutMoveUnlocked) {
        var refCenter = this.clampRotatedRectCenterToPrintable(
          ref.xMm + ref.lengthMm / 2,
          ref.yMm + refTotalHeight / 2,
          ref.lengthMm,
          refTotalHeight,
          ref.rotationDeg || 0,
          paper
        );
        ref.xMm = refCenter.x - ref.lengthMm / 2;
        ref.yMm = refCenter.y - refTotalHeight / 2;
      }
      this.drawSingleReferenceBar(ctx, view, ref);
    }
    ctx.restore();
  };

  ScaleBarBuilder.prototype.drawDistanceLabels = function (ctx, view, tags, options) {
    var activeTags = tags || this.getActiveTags();
    if (!activeTags || activeTags.length < 2) {
      return;
    }
    var opts = options || {};
    var drawLines = opts.drawLines !== false;
    var drawLabels = opts.drawLabels !== false;
    var addLineHits = opts.addLineHits !== false;
    var addLabelHits = opts.addLabelHits !== false;

    var edges = this.getDistanceEdges(activeTags);
    this.ensureDistanceAnnotations(edges);
    this.distanceRenderCache = {};

    ctx.save();
    ctx.globalAlpha = clamp(ctx.globalAlpha * (this.sceneVisualAlpha || 1), 0, 1);
    ctx.strokeStyle = 'rgba(44, 62, 80, 0.76)';
    ctx.fillStyle = 'rgba(31, 41, 51, 0.95)';
    ctx.lineWidth = Math.max(1.2, 0.18 * view.scale);
    var distanceFontPx = this.isExportRender
      ? Math.max(9, 2.8 * view.scale)
      : this.scalePreviewPx(Math.max(11 * this.pixelRatio, 12));
    ctx.font = distanceFontPx + 'px "IBM Plex Mono", monospace';

    for (var i = 0; i < edges.length; i += 1) {
      var edge = edges[i];
      var a = activeTags[edge.a];
      var b = activeTags[edge.b];
      if (!a || !b) {
        continue;
      }

      var dx = b.xMm - a.xMm;
      var dy = b.yMm - a.yMm;
      var distMm = Math.sqrt(dx * dx + dy * dy);
      var keepoutA = this.getTagCenterKeepoutMm(this.getTagSizeMm(edge.a));
      var keepoutB = this.getTagCenterKeepoutMm(this.getTagSizeMm(edge.b));
      if (distMm <= keepoutA + keepoutB + 0.1) {
        continue;
      }

      var ux = dx / distMm;
      var uy = dy / distMm;
      var nx = -uy;
      var ny = ux;
      var minT = keepoutA / distMm;
      var maxT = 1 - (keepoutB / distMm);
      var annotation = this.getDistanceAnnotation(edge.key);
      annotation.t = clamp(annotation.t, minT, maxT);
      annotation.normalOffsetMm = clamp(annotation.normalOffsetMm, -MAX_DISTANCE_OFFSET_MM, MAX_DISTANCE_OFFSET_MM);
      this.state.distanceAnnotations[edge.key] = annotation;

      var labelAlongMm = distMm * annotation.t;
      var normalOffsetMm = annotation.normalOffsetMm || 0;
      var labelXmm = a.xMm + ux * labelAlongMm + nx * normalOffsetMm;
      var labelYmm = a.yMm + uy * labelAlongMm + ny * normalOffsetMm;
      var lineStartXmm = a.xMm + ux * keepoutA + nx * normalOffsetMm;
      var lineStartYmm = a.yMm + uy * keepoutA + ny * normalOffsetMm;
      var lineEndXmm = b.xMm - ux * keepoutB + nx * normalOffsetMm;
      var lineEndYmm = b.yMm - uy * keepoutB + ny * normalOffsetMm;
      var distanceText = this.formatDistanceMm(distMm);
      var textWidthPx = ctx.measureText(distanceText).width;
      var textWidthMm = textWidthPx / view.scale;
      // Keep label margins locked to text metrics so zoom changes do not desync box/text sizing.
      var labelPadMm = Math.max(0.8, (distanceFontPx * 0.28) / view.scale);
      var labelHeightMm = Math.max(3.6, (distanceFontPx * 1.28) / view.scale);
      var labelBoxWmm = textWidthMm + labelPadMm * 2;
      var labelBoxHmm = labelHeightMm;
      var gapHalfMm = labelBoxWmm / 2 + 0.8;
      var lineStartAlongMm = keepoutA;
      var lineEndAlongMm = distMm - keepoutB;
      var leftStopAlongMm = clamp(labelAlongMm - gapHalfMm, lineStartAlongMm, lineEndAlongMm);
      var rightStartAlongMm = clamp(labelAlongMm + gapHalfMm, lineStartAlongMm, lineEndAlongMm);
      var leftStopXmm = a.xMm + ux * leftStopAlongMm + nx * normalOffsetMm;
      var leftStopYmm = a.yMm + uy * leftStopAlongMm + ny * normalOffsetMm;
      var rightStartXmm = a.xMm + ux * rightStartAlongMm + nx * normalOffsetMm;
      var rightStartYmm = a.yMm + uy * rightStartAlongMm + ny * normalOffsetMm;
      var angleRad = Math.atan2(dy, dx);
      if (angleRad > Math.PI / 2 || angleRad < -Math.PI / 2) {
        angleRad += Math.PI;
      }
      var angleDeg = (angleRad * 180) / Math.PI;
      var selected = this.state.selectedEntity && this.state.selectedEntity.type === 'distance' && this.state.selectedEntity.id === edge.key;

      var lineStartPx = this.paperToCanvas(lineStartXmm, lineStartYmm, view);
      var lineEndPx = this.paperToCanvas(lineEndXmm, lineEndYmm, view);
      var labelPx = this.paperToCanvas(labelXmm, labelYmm, view);
      var leftStopPx = this.paperToCanvas(leftStopXmm, leftStopYmm, view);
      var rightStartPx = this.paperToCanvas(rightStartXmm, rightStartYmm, view);

      var descriptorMuted = !!annotation.hidden;
      var lineColor = descriptorMuted
        ? 'rgba(122, 132, 145, 0.36)'
        : (selected ? 'rgba(22, 101, 216, 0.95)' : 'rgba(44, 62, 80, 0.76)');
      var labelFill = descriptorMuted
        ? 'rgba(255, 255, 255, 0.55)'
        : (selected ? 'rgba(224, 240, 255, 0.96)' : 'rgba(255, 255, 255, 0.9)');
      var labelStroke = descriptorMuted
        ? 'rgba(122, 132, 145, 0.4)'
        : (selected ? 'rgba(22, 101, 216, 0.95)' : 'rgba(31, 41, 51, 0.35)');
      var labelText = descriptorMuted ? 'rgba(101, 112, 125, 0.62)' : 'rgba(31, 41, 51, 0.95)';

      if (drawLines) {
        ctx.strokeStyle = lineColor;
        if (leftStopAlongMm > lineStartAlongMm + 0.01) {
          ctx.beginPath();
          ctx.moveTo(lineStartPx.x, lineStartPx.y);
          ctx.lineTo(leftStopPx.x, leftStopPx.y);
          ctx.stroke();
        }
        if (lineEndAlongMm > rightStartAlongMm + 0.01) {
          ctx.beginPath();
          ctx.moveTo(rightStartPx.x, rightStartPx.y);
          ctx.lineTo(lineEndPx.x, lineEndPx.y);
          ctx.stroke();
        }
      }

      if (drawLabels) {
        ctx.save();
        ctx.translate(labelPx.x, labelPx.y);
        ctx.rotate(angleRad);
        ctx.fillStyle = labelFill;
        ctx.strokeStyle = labelStroke;
        ctx.lineWidth = Math.max(1, 0.1 * view.scale);
        ctx.fillRect((-labelBoxWmm / 2) * view.scale, (-labelBoxHmm / 2) * view.scale, labelBoxWmm * view.scale, labelBoxHmm * view.scale);
        ctx.strokeRect((-labelBoxWmm / 2) * view.scale, (-labelBoxHmm / 2) * view.scale, labelBoxWmm * view.scale, labelBoxHmm * view.scale);
        ctx.fillStyle = labelText;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(distanceText, 0, 0);
        ctx.restore();
      }

      if (addLabelHits) {
        var labelAabb = this.getRotatedRectAabb(
          labelXmm - labelBoxWmm / 2,
          labelYmm - labelBoxHmm / 2,
          labelBoxWmm,
          labelBoxHmm,
          angleDeg
        );
        this.hitRegions.push({
          kind: 'distance-annotation',
          id: edge.key,
          xMm: labelAabb.x,
          yMm: labelAabb.y,
          wMm: Math.max(2, labelAabb.w),
          hMm: Math.max(2, labelAabb.h),
          hitTest: 'rotated-rect',
          vertices: [
            { x: labelAabb.corners.tl.x, y: labelAabb.corners.tl.y },
            { x: labelAabb.corners.tr.x, y: labelAabb.corners.tr.y },
            { x: labelAabb.corners.br.x, y: labelAabb.corners.br.y },
            { x: labelAabb.corners.bl.x, y: labelAabb.corners.bl.y }
          ],
          z: 46
        });
      }

      var lineMinX = Math.min(lineStartXmm, lineEndXmm, labelXmm) - 1.5;
      var lineMinY = Math.min(lineStartYmm, lineEndYmm, labelYmm) - 1.5;
      var lineMaxX = Math.max(lineStartXmm, lineEndXmm, labelXmm) + 1.5;
      var lineMaxY = Math.max(lineStartYmm, lineEndYmm, labelYmm) + 1.5;
      if (addLineHits) {
        this.hitRegions.push({
          kind: 'distance-annotation-line',
          id: edge.key,
          xMm: lineMinX,
          yMm: lineMinY,
          wMm: Math.max(2, lineMaxX - lineMinX),
          hMm: Math.max(2, lineMaxY - lineMinY),
          hitTest: 'polyline',
          toleranceMm: Math.max(0.5, 5 / view.scale),
          segments: [
            { x1: lineStartXmm, y1: lineStartYmm, x2: leftStopXmm, y2: leftStopYmm },
            { x1: rightStartXmm, y1: rightStartYmm, x2: lineEndXmm, y2: lineEndYmm }
          ],
          z: 38
        });
      }

      this.distanceRenderCache[edge.key] = {
        labelXmm: labelXmm,
        labelYmm: labelYmm,
        lineStartXmm: lineStartXmm,
        lineStartYmm: lineStartYmm,
        lineEndXmm: lineEndXmm,
        lineEndYmm: lineEndYmm,
        labelAlongMm: labelAlongMm,
        normalOffsetMm: normalOffsetMm,
        distanceMm: distMm,
        angleDeg: angleDeg,
        aIndex: edge.a,
        bIndex: edge.b
      };
    }
    ctx.restore();
  };

  ScaleBarBuilder.prototype.drawTag = function (ctx, view, paper, tag, index) {
    var sizeMm = this.getTagSizeMm(index);
    var sizePx = sizeMm * view.scale;
    var topLeft = this.paperToCanvas(tag.xMm - sizeMm / 2, tag.yMm - sizeMm / 2, view);
    ctx.save();
    ctx.globalAlpha = clamp(ctx.globalAlpha * (this.sceneVisualAlpha || 1), 0, 1);

    if (this.state.tagType === 'apriltag') {
      ctx.save();
      ctx.imageSmoothingEnabled = false;
      this.drawGeneratedAprilTag(ctx, topLeft.x, topLeft.y, sizePx, tag.id);
      ctx.restore();
    } else {
      var centerPx = this.paperToCanvas(tag.xMm, tag.yMm, view);
      if (this.state.tagFamily && this.state.tagFamily.indexOf('metashape-') === 0) {
        if (!this.drawGeneratedMetashapeCircularTag(ctx, centerPx.x, centerPx.y, sizePx / 2, tag.id)) {
          this.drawGeneratedCircularTag(ctx, centerPx.x, centerPx.y, sizePx / 2, tag.id);
        }
      } else {
        this.drawGeneratedCircularTag(ctx, centerPx.x, centerPx.y, sizePx / 2, tag.id);
      }
    }

    var keepout = this.getTagCenterKeepoutMm(sizeMm);
    var labelYmm = clamp(tag.yMm + keepout + 0.8, 0, Math.max(0, paper.height - 1));
    var labelPos = this.paperToCanvas(tag.xMm, labelYmm, view);
    var idText = this.getTagDisplayCode(tag.id);
    var relativeText = '';
    if (this.state.showRelativeCoordinates) {
      relativeText = this.getRelativeCoordinateText(tag.xMm, tag.yMm);
    }

    var idFontPx = this.isExportRender
      ? Math.max(8, 2.5 * view.scale)
      : this.scalePreviewPx(Math.max(10 * this.pixelRatio, 11));
    var relFontPx = this.isExportRender
      ? Math.max(7, 2 * view.scale)
      : this.scalePreviewPx(Math.max(8 * this.pixelRatio, 9));
    var idLineHeightPx = this.isExportRender ? (idFontPx * 1.12) : (idFontPx * 1.08);
    var relLineHeightPx = this.isExportRender ? (relFontPx * 1.1) : (relFontPx * 1.08);
    var textPadXPx = this.isExportRender ? Math.max(2, 0.8 * view.scale) : this.scalePreviewPx(Math.max(3 * this.pixelRatio, 3));
    var textPadYPx = this.isExportRender ? Math.max(2, 0.6 * view.scale) : this.scalePreviewPx(Math.max(2 * this.pixelRatio, 2));
    var lineGapPx = relativeText
      ? (this.isExportRender ? Math.max(1, 0.35 * view.scale) : this.scalePreviewPx(Math.max(1.5 * this.pixelRatio, 1.5)))
      : 0;

    ctx.save();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.font = idFontPx + 'px "IBM Plex Mono", monospace';
    var idWidthPx = ctx.measureText(idText).width;
    var relWidthPx = 0;
    if (relativeText) {
      ctx.font = relFontPx + 'px "IBM Plex Mono", monospace';
      relWidthPx = ctx.measureText(relativeText).width;
    }
    var textBlockWidthPx = Math.max(idWidthPx, relWidthPx);
    var textBlockHeightPx = idLineHeightPx + (relativeText ? (lineGapPx + relLineHeightPx) : 0);
    var bgX = labelPos.x - textBlockWidthPx / 2 - textPadXPx;
    var bgY = labelPos.y - textPadYPx;
    var bgW = textBlockWidthPx + textPadXPx * 2;
    var bgH = textBlockHeightPx + textPadYPx * 2;
    ctx.fillStyle = 'rgba(255, 255, 255, 0.92)';
    ctx.fillRect(bgX, bgY, bgW, bgH);

    ctx.fillStyle = 'rgba(20, 20, 20, 0.85)';
    ctx.font = idFontPx + 'px "IBM Plex Mono", monospace';
    ctx.fillText(idText, labelPos.x, labelPos.y);
    if (relativeText) {
      ctx.font = relFontPx + 'px "IBM Plex Mono", monospace';
      ctx.fillText(relativeText, labelPos.x, labelPos.y + idLineHeightPx + lineGapPx);
    }
    ctx.restore();
    ctx.restore();

    this.hitRegions.push({
      kind: 'tag',
      index: index,
      xMm: tag.xMm - sizeMm / 2,
      yMm: tag.yMm - sizeMm / 2,
      wMm: sizeMm,
      hMm: sizeMm,
      hitTest: this.state.tagType === 'circular' ? 'circle' : 'rect',
      cxMm: tag.xMm,
      cyMm: tag.yMm,
      rMm: sizeMm / 2,
      z: 50
    });
  };

  ScaleBarBuilder.prototype.drawRelativeCoordinateBadge = function (ctx, view, xMm, yMm, text) {
    if (!text) {
      return;
    }
    var labelPos = this.paperToCanvas(xMm, yMm, view);
    var relFontPx = this.isExportRender
      ? Math.max(7, 2 * view.scale)
      : this.scalePreviewPx(Math.max(8 * this.pixelRatio, 9));
    var relLineHeightPx = this.isExportRender
      ? (relFontPx * 1.1)
      : (relFontPx * 1.08);
    var textPadXPx = this.isExportRender
      ? Math.max(2, 0.8 * view.scale)
      : this.scalePreviewPx(Math.max(3 * this.pixelRatio, 3));
    var textPadYPx = this.isExportRender
      ? Math.max(2, 0.6 * view.scale)
      : this.scalePreviewPx(Math.max(2 * this.pixelRatio, 2));

    ctx.save();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    ctx.font = relFontPx + 'px "IBM Plex Mono", monospace';
    var textWidthPx = ctx.measureText(text).width;
    var bgX = labelPos.x - textWidthPx / 2 - textPadXPx;
    var bgY = labelPos.y - textPadYPx;
    var bgW = textWidthPx + textPadXPx * 2;
    var bgH = relLineHeightPx + textPadYPx * 2;
    ctx.fillStyle = 'rgba(255, 255, 255, 0.92)';
    ctx.fillRect(bgX, bgY, bgW, bgH);
    ctx.fillStyle = 'rgba(20, 20, 20, 0.85)';
    ctx.fillText(text, labelPos.x, labelPos.y);
    ctx.restore();
  };

  ScaleBarBuilder.prototype.drawAprilTagQuietZones = function (ctx, view, tags) {
    if (this.state.tagType !== 'apriltag' || !Array.isArray(tags) || tags.length === 0) {
      return;
    }
    ctx.save();
    ctx.globalAlpha = clamp(ctx.globalAlpha * (this.sceneVisualAlpha || 1), 0, 1);
    ctx.fillStyle = '#ffffff';
    for (var i = 0; i < tags.length; i += 1) {
      var tag = tags[i];
      if (!tag) {
        continue;
      }
      var sizeMm = this.getTagSizeMm(i);
      var marginMm = (sizeMm * APRILTAG_QUIET_ZONE_TOTAL_FRACTION) / 2;
      var outerSizeMm = sizeMm + marginMm * 2;
      var topLeft = this.paperToCanvas(
        tag.xMm - outerSizeMm / 2,
        tag.yMm - outerSizeMm / 2,
        view
      );
      var outerSizePx = outerSizeMm * view.scale;
      ctx.fillRect(topLeft.x, topLeft.y, outerSizePx, outerSizePx);
    }
    ctx.restore();
  };

  ScaleBarBuilder.prototype.drawCircularTagQuietZones = function (ctx, view, tags) {
    if (this.state.tagType !== 'circular' || !this.state.tagFamily || this.state.tagFamily.indexOf('metashape-') !== 0 || !Array.isArray(tags) || tags.length === 0) {
      return;
    }
    ctx.save();
    ctx.globalAlpha = clamp(ctx.globalAlpha * (this.sceneVisualAlpha || 1), 0, 1);
    ctx.fillStyle = '#ffffff';
    for (var i = 0; i < tags.length; i += 1) {
      var tag = tags[i];
      if (!tag) {
        continue;
      }
      var sizeMm = this.getTagSizeMm(i);
      var center = this.paperToCanvas(tag.xMm, tag.yMm, view);
      var radiusPx = (sizeMm * view.scale * 0.5) * METASHAPE_CIRCULAR_QUIET_ZONE_RADIUS_MULTIPLIER;
      ctx.beginPath();
      ctx.arc(center.x, center.y, radiusPx, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.restore();
  };

  ScaleBarBuilder.prototype.drawCutExteriorDimensions = function (ctx, view, paper, bbox) {
    if (!bbox || bbox.wMm <= 0.1 || bbox.hMm <= 0.1) {
      return;
    }

    var offsetMm = 3.2;
    var extTickMm = 1.4;
    var topSideY = bbox.yMm;
    var bottomSideY = bbox.yMm + bbox.hMm;
    var leftSideX = bbox.xMm;
    var rightSideX = bbox.xMm + bbox.wMm;

    var topY = topSideY - offsetMm;
    var topUsesBottom = false;
    if (topY < 0.8) {
      topY = bottomSideY + offsetMm;
      topUsesBottom = true;
    }

    var leftX = leftSideX - offsetMm;
    var leftUsesRight = false;
    if (leftX < 0.8) {
      leftX = rightSideX + offsetMm;
      leftUsesRight = true;
    }

    var topLabel = this.formatDistanceMm(bbox.wMm);
    var leftLabel = this.formatDistanceMm(bbox.hMm);

    ctx.save();
    ctx.strokeStyle = 'rgba(192, 86, 33, 0.28)';
    ctx.fillStyle = 'rgba(31, 41, 51, 0.42)';
    ctx.lineWidth = Math.max(1, 0.12 * view.scale);
    ctx.setLineDash([]);
    ctx.font = this.scalePreviewPx(Math.max(8 * this.pixelRatio, 8.8)) + 'px "IBM Plex Mono", monospace';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    var hStart = this.paperToCanvas(leftSideX, topY, view);
    var hEnd = this.paperToCanvas(rightSideX, topY, view);
    ctx.beginPath();
    ctx.moveTo(hStart.x, hStart.y);
    ctx.lineTo(hEnd.x, hEnd.y);
    ctx.stroke();

    var hExtFromY = topUsesBottom ? bottomSideY : topSideY;
    var hExtLeftA = this.paperToCanvas(leftSideX, hExtFromY, view);
    var hExtLeftB = this.paperToCanvas(leftSideX, topY, view);
    var hExtRightA = this.paperToCanvas(rightSideX, hExtFromY, view);
    var hExtRightB = this.paperToCanvas(rightSideX, topY, view);
    ctx.beginPath();
    ctx.moveTo(hExtLeftA.x, hExtLeftA.y);
    ctx.lineTo(hExtLeftB.x, hExtLeftB.y);
    ctx.moveTo(hExtRightA.x, hExtRightA.y);
    ctx.lineTo(hExtRightB.x, hExtRightB.y);
    ctx.stroke();

    var hTick = extTickMm * view.scale;
    ctx.beginPath();
    ctx.moveTo(hStart.x, hStart.y - hTick);
    ctx.lineTo(hStart.x, hStart.y + hTick);
    ctx.moveTo(hEnd.x, hEnd.y - hTick);
    ctx.lineTo(hEnd.x, hEnd.y + hTick);
    ctx.stroke();

    var topTextWidth = ctx.measureText(topLabel).width;
    var topPadX = this.scalePreviewPx(Math.max(4 * this.pixelRatio, 4));
    var topPadY = this.scalePreviewPx(Math.max(2 * this.pixelRatio, 2));
    var topLabelCx = (hStart.x + hEnd.x) / 2;
    var topLabelCy = hStart.y - this.scalePreviewPx(Math.max(8 * this.pixelRatio, 8));
    ctx.fillStyle = 'rgba(255, 255, 255, 0.62)';
    ctx.fillRect(
      topLabelCx - topTextWidth / 2 - topPadX,
      topLabelCy - (7 * this.pixelRatio) - topPadY,
      topTextWidth + topPadX * 2,
      (14 * this.pixelRatio) + topPadY * 2
    );
    ctx.fillStyle = 'rgba(31, 41, 51, 0.46)';
    ctx.fillText(topLabel, topLabelCx, topLabelCy);

    var vStart = this.paperToCanvas(leftX, topSideY, view);
    var vEnd = this.paperToCanvas(leftX, bottomSideY, view);
    ctx.beginPath();
    ctx.moveTo(vStart.x, vStart.y);
    ctx.lineTo(vEnd.x, vEnd.y);
    ctx.stroke();

    var vExtFromX = leftUsesRight ? rightSideX : leftSideX;
    var vExtTopA = this.paperToCanvas(vExtFromX, topSideY, view);
    var vExtTopB = this.paperToCanvas(leftX, topSideY, view);
    var vExtBottomA = this.paperToCanvas(vExtFromX, bottomSideY, view);
    var vExtBottomB = this.paperToCanvas(leftX, bottomSideY, view);
    ctx.beginPath();
    ctx.moveTo(vExtTopA.x, vExtTopA.y);
    ctx.lineTo(vExtTopB.x, vExtTopB.y);
    ctx.moveTo(vExtBottomA.x, vExtBottomA.y);
    ctx.lineTo(vExtBottomB.x, vExtBottomB.y);
    ctx.stroke();

    var vTick = extTickMm * view.scale;
    ctx.beginPath();
    ctx.moveTo(vStart.x - vTick, vStart.y);
    ctx.lineTo(vStart.x + vTick, vStart.y);
    ctx.moveTo(vEnd.x - vTick, vEnd.y);
    ctx.lineTo(vEnd.x + vTick, vEnd.y);
    ctx.stroke();

    var leftTextWidth = ctx.measureText(leftLabel).width;
    var leftLabelCx = vStart.x - this.scalePreviewPx(Math.max(10 * this.pixelRatio, 10));
    var leftLabelCy = (vStart.y + vEnd.y) / 2;
    ctx.save();
    ctx.translate(leftLabelCx, leftLabelCy);
    ctx.rotate(-Math.PI / 2);
    ctx.fillStyle = 'rgba(255, 255, 255, 0.62)';
    ctx.fillRect(
      -leftTextWidth / 2 - topPadX,
      -(7 * this.pixelRatio) - topPadY,
      leftTextWidth + topPadX * 2,
      (14 * this.pixelRatio) + topPadY * 2
    );
    ctx.fillStyle = 'rgba(31, 41, 51, 0.46)';
    ctx.fillText(leftLabel, 0, 0);
    ctx.restore();

    ctx.restore();
  };

  ScaleBarBuilder.prototype.drawCutLines = function (ctx, view, points, paper) {
    var cutMode = this.sanitizeCutShapeMode(this.state.cutShapeMode);
    if (cutMode === 'manual') {
      this.drawManualCutLines(ctx, view, paper);
      return;
    }
    var vertices = this.getAutoCutOutlineVertices(points, paper);
    if (vertices.length < 2) {
      return;
    }
    cutMode = this.sanitizeCutShapeMode(this.state.cutShapeMode);

    ctx.save();
    ctx.globalAlpha = clamp(ctx.globalAlpha * (this.sceneVisualAlpha || 1), 0, 1);
    ctx.strokeStyle = 'rgba(192, 86, 33, 0.92)';
    ctx.lineWidth = Math.max(1, 0.24 * view.scale);
    if (this.isExportRender) {
      // Keep cut dashes physically consistent across DPI settings (tighter spacing).
      ctx.setLineDash([1.25 * view.scale, 0.85 * view.scale]);
    } else {
      ctx.setLineDash([6 * this.pixelRatio, 4 * this.pixelRatio]);
    }
    ctx.beginPath();
    var start = this.paperToCanvas(vertices[0].x, vertices[0].y, view);
    ctx.moveTo(start.x, start.y);
    for (var i = 1; i < vertices.length; i += 1) {
      var p = this.paperToCanvas(vertices[i].x, vertices[i].y, view);
      ctx.lineTo(p.x, p.y);
    }
    ctx.closePath();
    ctx.stroke();
    ctx.setLineDash([]);

    var bbox = this.state.cutShape && this.state.cutShape.bbox ? this.state.cutShape.bbox : this.getVerticesBbox(vertices);
    var cutSegments = [];
    for (var s = 0; s < vertices.length; s += 1) {
      var sv1 = vertices[s];
      var sv2 = vertices[(s + 1) % vertices.length];
      cutSegments.push({
        x1: sv1.x,
        y1: sv1.y,
        x2: sv2.x,
        y2: sv2.y
      });
    }
    this.hitRegions.push({
      kind: 'cut-body',
      xMm: bbox.xMm,
      yMm: bbox.yMm,
      wMm: Math.max(2, bbox.wMm),
      hMm: Math.max(2, bbox.hMm),
      hitTest: 'polyline',
      toleranceMm: Math.max(0.8, (9 * this.pixelRatio) / Math.max(0.0001, view.scale)),
      segments: cutSegments,
      z: 30
    });

    if (!this.isExportRender) {
      this.drawCutExteriorDimensions(ctx, view, paper, bbox);

      if (cutMode === 'circle') {
        this.state.cutCircle = this.sanitizeCutCircle(this.state.cutCircle);
        var c = this.state.cutCircle;
        var radiusMm = Math.max(1, c.diameterMm / 2);
        var handleMm = {
          x: c.centerXMm + radiusMm,
          y: c.centerYMm
        };
        var handlePx = this.paperToCanvas(handleMm.x, handleMm.y, view);
        var hrPx = Math.max(5, 2.1 * view.scale);
        var hrMm = hrPx / Math.max(0.0001, view.scale);
        ctx.save();
        ctx.fillStyle = 'rgba(22, 101, 216, 0.95)';
        ctx.beginPath();
        ctx.arc(handlePx.x, handlePx.y, hrPx, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
        this.hitRegions.push({
          kind: 'cut-circle-handle',
          hitTest: 'circle',
          cxMm: handleMm.x,
          cyMm: handleMm.y,
          rMm: hrMm + (8 * this.pixelRatio) / Math.max(0.0001, view.scale),
          xMm: handleMm.x - hrMm,
          yMm: handleMm.y - hrMm,
          wMm: hrMm * 2,
          hMm: hrMm * 2,
          z: 95
        });
      }

      var toggleSizeMm = 6;
      var togglePadMm = 1;
      var toggleHitGraceMm = (10 * this.pixelRatio) / Math.max(0.0001, view.scale);
      var toggleXmm = clamp(bbox.xMm + bbox.wMm - toggleSizeMm - togglePadMm, 0, Math.max(0, paper.width - toggleSizeMm));
      var toggleYmm = clamp(bbox.yMm + togglePadMm, 0, Math.max(0, paper.height - toggleSizeMm));
      var togglePx = this.paperToCanvas(toggleXmm, toggleYmm, view);
      var toggleSizePx = toggleSizeMm * view.scale;

      this.hitRegions.push({
        kind: 'cut-move-toggle',
        xMm: toggleXmm - toggleHitGraceMm,
        yMm: toggleYmm - toggleHitGraceMm,
        wMm: toggleSizeMm + toggleHitGraceMm * 2,
        hMm: toggleSizeMm + toggleHitGraceMm * 2,
        z: 96
      });

      ctx.save();
      ctx.fillStyle = this.state.cutMoveUnlocked ? 'rgba(22, 101, 216, 0.95)' : 'rgba(55, 65, 81, 0.95)';
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.95)';
      ctx.lineWidth = Math.max(1, 0.07 * view.scale);
      ctx.fillRect(togglePx.x, togglePx.y, toggleSizePx, toggleSizePx);
      ctx.strokeRect(togglePx.x, togglePx.y, toggleSizePx, toggleSizePx);

      var bodyW = toggleSizePx * 0.42;
      var bodyH = toggleSizePx * 0.30;
      var bodyX = togglePx.x + (toggleSizePx - bodyW) / 2;
      var bodyY = togglePx.y + toggleSizePx * 0.49;
      ctx.fillStyle = 'rgba(255, 255, 255, 0.95)';
      ctx.fillRect(bodyX, bodyY, bodyW, bodyH);

      var shackleR = toggleSizePx * 0.18;
      var shackleCx = togglePx.x + toggleSizePx / 2;
      var shackleCy = bodyY;
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.95)';
      ctx.lineWidth = Math.max(1, 0.1 * view.scale);
      ctx.beginPath();
      ctx.arc(shackleCx, shackleCy, shackleR, Math.PI, 0, false);
      if (this.state.cutMoveUnlocked) {
        ctx.moveTo(shackleCx + shackleR, shackleCy);
        ctx.lineTo(shackleCx + shackleR, bodyY + shackleR * 0.7);
      } else {
        ctx.moveTo(shackleCx - shackleR, shackleCy);
        ctx.lineTo(shackleCx - shackleR, bodyY + shackleR * 0.7);
        ctx.moveTo(shackleCx + shackleR, shackleCy);
        ctx.lineTo(shackleCx + shackleR, bodyY + shackleR * 0.7);
      }
      ctx.stroke();
      ctx.restore();
    }

    // Cut line scaling handles intentionally disabled.
    ctx.restore();
  };

  ScaleBarBuilder.prototype.drawManualCutLines = function (ctx, view, paper) {
    var manual = this.getCutManualState();
    var nodes = Array.isArray(manual.nodes) ? manual.nodes : [];
    if (!nodes.length) {
      this.state.cutShape = {
        vertices: [],
        bbox: { xMm: 0, yMm: 0, wMm: 0, hMm: 0 }
      };
      return;
    }

    var segmentCount = manual.closed ? nodes.length : Math.max(0, nodes.length - 1);
    var drawClosed = !!manual.closed && nodes.length >= 3;

    ctx.save();
    ctx.globalAlpha = clamp(ctx.globalAlpha * (this.sceneVisualAlpha || 1), 0, 1);
    ctx.strokeStyle = 'rgba(192, 86, 33, 0.92)';
    ctx.lineWidth = Math.max(1, 0.24 * view.scale);
    if (this.isExportRender) {
      ctx.setLineDash([1.25 * view.scale, 0.85 * view.scale]);
    } else {
      ctx.setLineDash([6 * this.pixelRatio, 4 * this.pixelRatio]);
    }
    ctx.beginPath();
    var start = this.paperToCanvas(nodes[0].x, nodes[0].y, view);
    ctx.moveTo(start.x, start.y);
    for (var si = 0; si < segmentCount; si += 1) {
      var a = nodes[si];
      var b = nodes[(si + 1) % nodes.length];
      var curved = this.isCutManualNodeBezier(a) || this.isCutManualNodeBezier(b);
      var cp1 = this.paperToCanvas(parseNumber(a.outX, a.x), parseNumber(a.outY, a.y), view);
      var cp2 = this.paperToCanvas(parseNumber(b.inX, b.x), parseNumber(b.inY, b.y), view);
      var end = this.paperToCanvas(b.x, b.y, view);
      if (curved) {
        ctx.bezierCurveTo(cp1.x, cp1.y, cp2.x, cp2.y, end.x, end.y);
      } else {
        ctx.lineTo(end.x, end.y);
      }
    }
    if (drawClosed) {
      ctx.closePath();
    }
    ctx.stroke();
    ctx.setLineDash([]);

    if (manual.tool === 'draw' && !manual.closed && nodes.length > 0 && this.manualCutPreviewPointerMm && (!this.dragState || this.dragState.type !== 'cut-manual-new-point-handle')) {
      var lastNode = nodes[nodes.length - 1];
      var previewNode = this.manualCutPreviewPointerMm;
      var lastPx = this.paperToCanvas(lastNode.x, lastNode.y, view);
      var previewPx = this.paperToCanvas(previewNode.x, previewNode.y, view);
      ctx.save();
      ctx.strokeStyle = 'rgba(22, 101, 216, 0.88)';
      ctx.lineWidth = Math.max(1, 0.14 * view.scale);
      if (this.isExportRender) {
        ctx.setLineDash([1.1 * view.scale, 0.8 * view.scale]);
      } else {
        ctx.setLineDash([5 * this.pixelRatio, 4 * this.pixelRatio]);
      }
      ctx.beginPath();
      ctx.moveTo(lastPx.x, lastPx.y);
      ctx.lineTo(previewPx.x, previewPx.y);
      ctx.stroke();
      ctx.setLineDash([]);
      ctx.fillStyle = 'rgba(22, 101, 216, 0.96)';
      ctx.beginPath();
      ctx.arc(previewPx.x, previewPx.y, Math.max(2.6, 1.4 * view.scale), 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    }

    var handleRadiusMm = Math.max(0.6, (6 * this.pixelRatio) / Math.max(0.0001, view.scale));
    var anchorRadiusMm = Math.max(0.7, (7 * this.pixelRatio) / Math.max(0.0001, view.scale));
    var selectedIdx = clamp(parseNumber(manual.selectedPointIndex, -1), -1, nodes.length - 1);
    var cutSelected = !!(this.state.selectedEntity && this.state.selectedEntity.type === 'cut');
    var showHandles = cutSelected && (manual.tool === 'edit' || manual.tool === 'draw');
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      var nodePx = this.paperToCanvas(node.x, node.y, view);
      if (showHandles && this.isCutManualNodeBezier(node)) {
        var inPx = this.paperToCanvas(parseNumber(node.inX, node.x), parseNumber(node.inY, node.y), view);
        var outPx = this.paperToCanvas(parseNumber(node.outX, node.x), parseNumber(node.outY, node.y), view);
        ctx.save();
        ctx.strokeStyle = 'rgba(31, 41, 51, 0.55)';
        ctx.lineWidth = Math.max(1, 0.1 * view.scale);
        ctx.beginPath();
        ctx.moveTo(nodePx.x, nodePx.y);
        ctx.lineTo(inPx.x, inPx.y);
        ctx.moveTo(nodePx.x, nodePx.y);
        ctx.lineTo(outPx.x, outPx.y);
        ctx.stroke();
        ctx.fillStyle = 'rgba(22, 101, 216, 0.92)';
        ctx.beginPath();
        ctx.arc(inPx.x, inPx.y, Math.max(3, 1.3 * view.scale), 0, Math.PI * 2);
        ctx.fill();
        ctx.beginPath();
        ctx.arc(outPx.x, outPx.y, Math.max(3, 1.3 * view.scale), 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();

        this.hitRegions.push({
          kind: 'cut-manual-handle-in',
          index: i,
          hitTest: 'circle',
          cxMm: parseNumber(node.inX, node.x),
          cyMm: parseNumber(node.inY, node.y),
          rMm: handleRadiusMm,
          xMm: parseNumber(node.inX, node.x) - handleRadiusMm,
          yMm: parseNumber(node.inY, node.y) - handleRadiusMm,
          wMm: handleRadiusMm * 2,
          hMm: handleRadiusMm * 2,
          z: 101
        });
        this.hitRegions.push({
          kind: 'cut-manual-handle-out',
          index: i,
          hitTest: 'circle',
          cxMm: parseNumber(node.outX, node.x),
          cyMm: parseNumber(node.outY, node.y),
          rMm: handleRadiusMm,
          xMm: parseNumber(node.outX, node.x) - handleRadiusMm,
          yMm: parseNumber(node.outY, node.y) - handleRadiusMm,
          wMm: handleRadiusMm * 2,
          hMm: handleRadiusMm * 2,
          z: 101
        });
      }

      if (cutSelected) {
        ctx.save();
        ctx.fillStyle = i === selectedIdx ? 'rgba(22, 101, 216, 0.98)' : 'rgba(192, 86, 33, 0.95)';
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.95)';
        ctx.lineWidth = Math.max(1, 0.08 * view.scale);
        ctx.beginPath();
        ctx.arc(nodePx.x, nodePx.y, Math.max(3.2, 1.7 * view.scale), 0, Math.PI * 2);
        ctx.fill();
        ctx.stroke();
        ctx.restore();

        this.hitRegions.push({
          kind: 'cut-manual-point',
          index: i,
          hitTest: 'circle',
          cxMm: node.x,
          cyMm: node.y,
          rMm: anchorRadiusMm,
          xMm: node.x - anchorRadiusMm,
          yMm: node.y - anchorRadiusMm,
          wMm: anchorRadiusMm * 2,
          hMm: anchorRadiusMm * 2,
          z: 102
        });
      }
    }

    if (!drawClosed && nodes.length >= 3 && manual.tool === 'draw') {
      var firstNode = nodes[0];
      var firstPx = this.paperToCanvas(firstNode.x, firstNode.y, view);
      ctx.save();
      ctx.fillStyle = 'rgba(22, 101, 216, 0.86)';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      ctx.font = Math.max(10, this.scalePreviewPx(Math.max(8 * this.pixelRatio, 9))) + 'px "IBM Plex Mono", monospace';
      ctx.fillText('Click first point to close loop', firstPx.x + Math.max(6, 2 * view.scale), firstPx.y - Math.max(8, 2.2 * view.scale));
      ctx.restore();
    } else if (!drawClosed && nodes.length > 0 && manual.tool !== 'draw') {
      var lastOpenNode = nodes[nodes.length - 1];
      var lastOpenPx = this.paperToCanvas(lastOpenNode.x, lastOpenNode.y, view);
      ctx.save();
      ctx.fillStyle = 'rgba(31, 41, 51, 0.82)';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      ctx.font = Math.max(10, this.scalePreviewPx(Math.max(8 * this.pixelRatio, 9))) + 'px "IBM Plex Mono", monospace';
      ctx.fillText('Path open. Click Draw to continue.', lastOpenPx.x + Math.max(6, 2 * view.scale), lastOpenPx.y - Math.max(8, 2.2 * view.scale));
      ctx.restore();
    }

    if (!drawClosed) {
      this.state.cutShape = {
        vertices: [],
        bbox: { xMm: 0, yMm: 0, wMm: 0, hMm: 0 }
      };
      ctx.restore();
      return;
    }

    var sampledVertices = this.buildCutManualVertices(manual);
    if (!sampledVertices.length) {
      this.state.cutShape = {
        vertices: [],
        bbox: { xMm: 0, yMm: 0, wMm: 0, hMm: 0 }
      };
      ctx.restore();
      return;
    }
    var bbox = this.getVerticesBbox(sampledVertices);
    this.state.cutShape = {
      vertices: sampledVertices,
      bbox: bbox
    };

    var cutSegments = [];
    for (var s = 0; s < sampledVertices.length; s += 1) {
      var sv1 = sampledVertices[s];
      var sv2 = sampledVertices[(s + 1) % sampledVertices.length];
      cutSegments.push({
        x1: sv1.x,
        y1: sv1.y,
        x2: sv2.x,
        y2: sv2.y
      });
    }
    this.hitRegions.push({
      kind: 'cut-body',
      xMm: bbox.xMm,
      yMm: bbox.yMm,
      wMm: Math.max(2, bbox.wMm),
      hMm: Math.max(2, bbox.hMm),
      hitTest: 'polygon',
      vertices: sampledVertices,
      segments: cutSegments,
      z: 30
    });

    if (!this.isExportRender) {
      this.drawCutExteriorDimensions(ctx, view, paper, bbox);
    }
    ctx.restore();
  };

  ScaleBarBuilder.prototype.doesGuideOverlapExistingTag = function (xMm, yMm, candidateSizeMm, excludeIndex, tagList) {
    var tags = Array.isArray(tagList) ? tagList : this.getActiveTags();
    var candidateHalf = Math.max(4, parseNumber(candidateSizeMm, this.state.tagSizeMm)) / 2;
    for (var i = 0; i < tags.length; i += 1) {
      if (typeof excludeIndex === 'number' && i === excludeIndex) {
        continue;
      }
      var tag = tags[i];
      if (!tag) {
        continue;
      }
      var existingHalf = this.getTagSizeMm(i) / 2;
      var minCenterDistance = Math.max(0, candidateHalf + existingHalf - 0.1);
      var dx = xMm - tag.xMm;
      var dy = yMm - tag.yMm;
      var dist = Math.sqrt(dx * dx + dy * dy);
      if (dist < minCenterDistance) {
        return true;
      }
    }
    return false;
  };

  ScaleBarBuilder.prototype.drawPlacementGuides = function (ctx, view, paper, tags) {
    if (!this.state.showPlacementGuides || !this.state.selectedEntity || this.state.selectedEntity.type !== 'tag') {
      return;
    }

    var idx = this.state.selectedEntity.id;
    if (typeof idx !== 'number' || idx < 0 || idx >= tags.length) {
      return;
    }

    var selected = tags[idx];
    var spacingMm = this.state.spacingCm * MM_PER_CM;
    var guidePoints = [
      { x: selected.xMm + spacingMm, y: selected.yMm },
      { x: selected.xMm - spacingMm, y: selected.yMm },
      { x: selected.xMm, y: selected.yMm + spacingMm },
      { x: selected.xMm, y: selected.yMm - spacingMm }
    ];
    var printable = this.getPrintableRect(paper, this.state.tagSizeMm / 2);

    ctx.save();
    ctx.strokeStyle = 'rgba(44, 82, 130, 0.8)';
    ctx.fillStyle = 'rgba(44, 82, 130, 0.18)';
    ctx.lineWidth = Math.max(1, 0.16 * view.scale);
    var guideHitGraceMm = (10 * this.pixelRatio) / Math.max(0.0001, view.scale);

    for (var i = 0; i < guidePoints.length; i += 1) {
      var g = guidePoints[i];
      if (g.x < printable.minX || g.x > printable.maxX || g.y < printable.minY || g.y > printable.maxY) {
        continue;
      }
      if (this.doesGuideOverlapExistingTag(g.x, g.y, this.state.tagSizeMm, idx, tags)) {
        continue;
      }
      var p = this.paperToCanvas(g.x, g.y, view);
      var radiusPx = Math.max(5, 2.2 * view.scale);
      var radiusMm = radiusPx / Math.max(0.0001, view.scale);
      var hitRadiusMm = radiusMm + guideHitGraceMm;
      ctx.beginPath();
      ctx.arc(p.x, p.y, radiusPx, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();

      this.hitRegions.push({
        kind: 'guide-add-tag',
        hitTest: 'circle',
        cxMm: g.x,
        cyMm: g.y,
        rMm: hitRadiusMm,
        xMm: g.x - hitRadiusMm,
        yMm: g.y - hitRadiusMm,
        wMm: hitRadiusMm * 2,
        hMm: hitRadiusMm * 2,
        guideXmm: g.x,
        guideYmm: g.y,
        z: 80
      });
    }

    ctx.restore();
  };

  ScaleBarBuilder.prototype.drawHomeCrosshair = function (ctx, view, paper) {
    if (this.isExportRender) {
      return;
    }
    var home = this.getHomePoint();
    if (!home || home.visible === false) {
      return;
    }
    home.xMm = clamp(home.xMm, 0, paper.width);
    home.yMm = clamp(home.yMm, 0, paper.height);
    var p = this.paperToCanvas(home.xMm, home.yMm, view);
    var armPx = Math.max(7, 2.6 * view.scale);
    var rPx = Math.max(4, 1.2 * view.scale);
    var rMm = rPx / Math.max(0.0001, view.scale);

    ctx.save();
    ctx.strokeStyle = 'rgba(31, 41, 51, 0.88)';
    ctx.lineWidth = Math.max(1, 0.12 * view.scale);
    ctx.beginPath();
    ctx.moveTo(p.x - armPx, p.y);
    ctx.lineTo(p.x + armPx, p.y);
    ctx.moveTo(p.x, p.y - armPx);
    ctx.lineTo(p.x, p.y + armPx);
    ctx.stroke();
    ctx.fillStyle = 'rgba(255, 255, 255, 0.96)';
    ctx.beginPath();
    ctx.arc(p.x, p.y, rPx, 0, Math.PI * 2);
    ctx.fill();
    ctx.strokeStyle = 'rgba(31, 41, 51, 0.72)';
    ctx.stroke();

    var labelWpx = Math.max(24, 5.6 * view.scale);
    var labelHpx = Math.max(12, 2.8 * view.scale);
    var labelX = p.x - labelWpx / 2;
    var labelY = p.y - armPx - labelHpx - Math.max(2, 0.8 * view.scale);
    ctx.fillStyle = 'rgba(255, 255, 255, 0.94)';
    ctx.strokeStyle = 'rgba(31, 41, 51, 0.66)';
    ctx.lineWidth = Math.max(1, 0.08 * view.scale);
    ctx.fillRect(labelX, labelY, labelWpx, labelHpx);
    ctx.strokeRect(labelX, labelY, labelWpx, labelHpx);
    ctx.fillStyle = 'rgba(31, 41, 51, 0.95)';
    ctx.font = Math.max(8, 2.3 * view.scale) + 'px "IBM Plex Sans", sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('HOME', labelX + labelWpx / 2, labelY + labelHpx / 2);
    ctx.restore();

    this.hitRegions.push({
      kind: 'home-point',
      hitTest: 'circle',
      cxMm: home.xMm,
      cyMm: home.yMm,
      rMm: Math.max(1.5, rMm + (8 * this.pixelRatio) / Math.max(0.0001, view.scale)),
      xMm: home.xMm - Math.max(1.5, rMm),
      yMm: home.yMm - Math.max(1.5, rMm),
      wMm: Math.max(3, rMm * 2),
      hMm: Math.max(3, rMm * 2),
      z: 94
    });
  };

  ScaleBarBuilder.prototype.applyLogoAutoPlacement = function (paper, tags) {
    this.state.logoAutoPlacement = true;
    var logo = this.findOverlayById(this.logoOverlayId);
    if (!logo) {
      return;
    }
    logo.locked = true;
    logo.rotationDeg = 0;
    logo.preserveAspect = true;

    var anchorPadMm = 2;
    var printable = this.getPrintableRect(paper, 0);
    var maxX = Math.max(printable.minX, printable.maxX - Math.max(2, logo.wMm));
    var maxY = Math.max(printable.minY, printable.maxY - Math.max(2, logo.hMm));
    var targetX = clamp(maxX - anchorPadMm, printable.minX, maxX);
    var targetY = clamp(maxY - anchorPadMm, printable.minY, maxY);
    logo.xMm = targetX;
    logo.yMm = targetY;
  };

  ScaleBarBuilder.prototype.drawShapeOverlay = function (ctx, view, item, drawX, drawY, drawW, drawH, rotationDeg) {
    var kind = item.shapeKind || 'rectangle';
    var cx = drawX + drawW / 2;
    var cy = drawY + drawH / 2;
    var centerPx = this.paperToCanvas(cx, cy, view);
    var wPx = drawW * view.scale;
    var hPx = drawH * view.scale;
    var linePx = Math.max(1, parseNumber(item.strokeWidthMm, 0.4) * view.scale);
    var fill = item.fillColor || '#000000';
    var stroke = item.strokeColor || '#000000';
    var alpha = clamp(parseNumber(item.opacity, 1), 0, 1) * (this.sceneVisualAlpha || 1);

    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.translate(centerPx.x, centerPx.y);
    ctx.rotate((rotationDeg * Math.PI) / 180);
    ctx.lineWidth = linePx;
    ctx.strokeStyle = stroke;
    ctx.fillStyle = fill;

    var x0 = -wPx / 2;
    var y0 = -hPx / 2;
    var x1 = wPx / 2;
    var y1 = hPx / 2;

    if (kind === 'line') {
      ctx.beginPath();
      ctx.moveTo(x0, 0);
      ctx.lineTo(x1, 0);
      ctx.stroke();
      ctx.restore();
      return;
    }

    if (kind === 'rectangle') {
      ctx.fillRect(x0, y0, wPx, hPx);
      if (linePx > 0) {
        ctx.strokeRect(x0, y0, wPx, hPx);
      }
      ctx.restore();
      return;
    }

    if (kind === 'circle') {
      ctx.beginPath();
      ctx.ellipse(0, 0, Math.abs(wPx / 2), Math.abs(hPx / 2), 0, 0, Math.PI * 2);
      ctx.fill();
      if (linePx > 0) {
        ctx.stroke();
      }
      ctx.restore();
      return;
    }

    if (kind === 'circle-quartered') {
      var rx = Math.abs(wPx / 2);
      var ry = Math.abs(hPx / 2);
      for (var qi = 0; qi < 4; qi += 1) {
        var qa0 = (Math.PI / 2) * qi;
        var qa1 = qa0 + (Math.PI / 2);
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.ellipse(0, 0, rx, ry, 0, qa0, qa1);
        ctx.closePath();
        ctx.fillStyle = (qi % 2 === 0) ? fill : '#ffffff';
        ctx.fill();
      }
      if (linePx > 0) {
        ctx.strokeStyle = stroke;
        ctx.beginPath();
        ctx.ellipse(0, 0, rx, ry, 0, 0, Math.PI * 2);
        ctx.stroke();
      }
      ctx.restore();
      return;
    }

    if (kind === 'compass-marker') {
      var triTipY = y0;
      var triBaseY = y0 + hPx * 0.78;
      var triHalfW = wPx * 0.48;
      var darkFill = fill;
      var lightFill = '#ffffff';

      ctx.fillStyle = darkFill;
      ctx.beginPath();
      ctx.moveTo(0, triTipY);
      ctx.lineTo(-triHalfW, triBaseY);
      ctx.lineTo(0, triBaseY);
      ctx.closePath();
      ctx.fill();

      ctx.fillStyle = lightFill;
      ctx.beginPath();
      ctx.moveTo(0, triTipY);
      ctx.lineTo(0, triBaseY);
      ctx.lineTo(triHalfW, triBaseY);
      ctx.closePath();
      ctx.fill();

      if (linePx > 0) {
        ctx.strokeStyle = stroke;
        ctx.beginPath();
        ctx.moveTo(0, triTipY);
        ctx.lineTo(-triHalfW, triBaseY);
        ctx.lineTo(triHalfW, triBaseY);
        ctx.closePath();
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(0, triTipY);
        ctx.lineTo(0, triBaseY);
        ctx.stroke();
      }

      var northTextY = y0 + hPx * 0.38;
      var northFontPx = Math.max(8, Math.min(wPx, hPx) * 0.42);
      ctx.font = '700 ' + northFontPx + 'px "IBM Plex Sans", sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.lineWidth = Math.max(1, northFontPx * 0.08);
      ctx.strokeStyle = 'rgba(0, 0, 0, 0.55)';
      ctx.fillStyle = 'rgba(255, 255, 255, 0.97)';
      ctx.strokeText('N', 0, northTextY);
      ctx.fillText('N', 0, northTextY);

      ctx.restore();
      return;
    }

    if (kind === 'cross') {
      var armRatio = clamp(parseNumber(item.armRatio, 0.24), 0.12, 0.8);
      var armW = wPx * armRatio;
      var armH = hPx * armRatio;
      ctx.beginPath();
      ctx.rect(-armW / 2, y0, armW, hPx);
      ctx.rect(x0, -armH / 2, wPx, armH);
      ctx.fill();
      if (linePx > 0) {
        ctx.strokeRect(-armW / 2, y0, armW, hPx);
        ctx.strokeRect(x0, -armH / 2, wPx, armH);
      }
      ctx.restore();
      return;
    }

    if (kind === 'grid') {
      var rows = clamp(Math.round(parseNumber(item.rows, 4)), 1, 32);
      var cols = clamp(Math.round(parseNumber(item.cols, 4)), 1, 32);
      var cellW = wPx / cols;
      var cellH = hPx / rows;
      for (var r = 0; r < rows; r += 1) {
        for (var c = 0; c < cols; c += 1) {
          if ((r + c) % 2 === 0) {
            ctx.fillRect(x0 + c * cellW, y0 + r * cellH, cellW, cellH);
          }
        }
      }
      if (linePx > 0) {
        ctx.strokeRect(x0, y0, wPx, hPx);
      }
      ctx.restore();
      return;
    }

    if (kind === 'circle-grid') {
      var ringCount = clamp(Math.round(parseNumber(item.ringCount, 3)), 1, 20);
      var spokeCount = clamp(Math.round(parseNumber(item.spokeCount, 8)), 1, 64);
      var maxR = Math.min(Math.abs(wPx), Math.abs(hPx)) / 2;
      for (var ri = 1; ri <= ringCount; ri += 1) {
        var rr = (maxR * ri) / ringCount;
        ctx.beginPath();
        ctx.arc(0, 0, rr, 0, Math.PI * 2);
        ctx.stroke();
      }
      for (var si = 0; si < spokeCount; si += 1) {
        var theta = (Math.PI * 2 * si) / spokeCount;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(Math.cos(theta) * maxR, Math.sin(theta) * maxR);
        ctx.stroke();
      }
      ctx.restore();
      return;
    }

    ctx.fillRect(x0, y0, wPx, hPx);
    if (linePx > 0) {
      ctx.strokeRect(x0, y0, wPx, hPx);
    }
    ctx.restore();
  };

  ScaleBarBuilder.prototype.drawOverlayItem = function (ctx, view, paper, item, tags) {
    if (!item.visible) {
      return;
    }

    var rotationDeg = this.normalizeRotation(item.rotationDeg || 0);
    var drawX = item.xMm;
    var drawY = item.yMm;
    var drawW = Math.max(2, item.wMm || 2);
    var drawH = Math.max(2, item.hMm || 2);

    if (item.type === 'info') {
      var infoOpacity = clamp(parseNumber(item.opacity, 1), 0.04, 1);
      if (this.isExportRender && infoOpacity <= (INFO_OVERLAY_DIMMED_OPACITY + 0.001)) {
        return;
      }
      var lines = this.getInfoWidgetLines();
      ctx.save();
      ctx.globalAlpha = infoOpacity;
      var fontMm = 3.2;
      var lineHeightMm = fontMm * 1.35;
      var paddingMm = 1.6;
      var anchorInsetMm = 2.4;
      ctx.font = Math.max(this.scalePreviewPx(Math.max(9 * this.pixelRatio, 9)), fontMm * view.scale) + 'px "IBM Plex Mono", monospace';

      var maxTextWidthPx = 0;
      for (var i = 0; i < lines.length; i += 1) {
        maxTextWidthPx = Math.max(maxTextWidthPx, ctx.measureText(lines[i]).width);
      }
      var boxWidthMm = maxTextWidthPx / view.scale + 2 * paddingMm;
      var boxHeightMm = lines.length * lineHeightMm + 2 * paddingMm;
      var printableInfo = this.getPrintableRect(paper, 0);
      var reserveForAttributionMm = this.getAttributionReserveMm();
      var anchorXmm = printableInfo.minX + anchorInsetMm;
      var anchorYmm = printableInfo.maxY - boxHeightMm - anchorInsetMm - reserveForAttributionMm;
      var infoPos = this.clampRectTopLeftToPrintable(anchorXmm, anchorYmm, boxWidthMm, boxHeightMm, paper);
      item.locked = true;
      item.xMm = infoPos.x;
      item.yMm = infoPos.y;
      item.wMm = boxWidthMm;
      item.hMm = boxHeightMm;
      drawX = item.xMm;
      drawY = item.yMm;
      drawW = boxWidthMm;
      drawH = boxHeightMm;

      var topLeftInfo = this.paperToCanvas(item.xMm, item.yMm, view);
      var boxWpx = boxWidthMm * view.scale;
      var boxHpx = boxHeightMm * view.scale;

      ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
      ctx.strokeStyle = 'rgba(31, 41, 51, 0.55)';
      ctx.lineWidth = Math.max(1, 0.14 * view.scale);
      ctx.fillRect(topLeftInfo.x, topLeftInfo.y, boxWpx, boxHpx);
      ctx.strokeRect(topLeftInfo.x, topLeftInfo.y, boxWpx, boxHpx);

      ctx.fillStyle = 'rgba(0, 0, 0, 0.86)';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';
      for (var lineIndex = 0; lineIndex < lines.length; lineIndex += 1) {
        var lineX = this.paperToCanvas(item.xMm + paddingMm, 0, view).x;
        var lineY = this.paperToCanvas(0, item.yMm + paddingMm + lineIndex * lineHeightMm, view).y;
        ctx.fillText(lines[lineIndex], lineX, lineY);
      }
      ctx.restore();
    } else if (item.type === 'text') {
      ctx.save();
      ctx.fillStyle = item.color || '#000000';
      ctx.globalAlpha = clamp(item.opacity, 0, 1) * (this.sceneVisualAlpha || 1);
      var textFontMm = this.getOverlayFontSizeMm(item);
      var textFontPx = Math.max(6 * this.pixelRatio, textFontMm * view.scale);
      ctx.font = textFontPx + 'px "' + (item.fontFamily || 'Space Grotesk') + '", sans-serif';
      ctx.textBaseline = 'top';

      var wrapWidthMm = Math.max(2, parseNumber(item.wMm, 40));
      var wrapWidthPx = Math.max(2, wrapWidthMm * view.scale);
      var linesText = this.layoutTextLinesForOverlay(ctx, item.text || '', wrapWidthPx);
      var lineWidths = [];
      var maxLineWidthPx = 0;
      var lineHeightPx = textFontPx * 1.25;
      for (var lw = 0; lw < linesText.length; lw += 1) {
        var widthPx = ctx.measureText(linesText[lw]).width;
        lineWidths.push(widthPx);
        maxLineWidthPx = Math.max(maxLineWidthPx, widthPx);
      }

      var resolvedWmm = Math.max(wrapWidthMm, maxLineWidthPx / Math.max(0.0001, view.scale));
      var resolvedHmm = Math.max(lineHeightPx / Math.max(0.0001, view.scale), (linesText.length || 1) * (lineHeightPx / Math.max(0.0001, view.scale)));
      var anchorX = parseNumber(item.xMm, 0);

      item.wMm = resolvedWmm;
      item.hMm = resolvedHmm;
      drawX = anchorX;
      drawY = item.yMm;
      drawW = Math.max(2, resolvedWmm);
      drawH = Math.max(2, resolvedHmm);

      var textCenterX = drawX + drawW / 2;
      var textCenterY = drawY + drawH / 2;
      var textCenterCanvas = this.paperToCanvas(textCenterX, textCenterY, view);
      ctx.translate(textCenterCanvas.x, textCenterCanvas.y);
      ctx.rotate((rotationDeg * Math.PI) / 180);
      ctx.textAlign = 'left';

      var localStartX = (drawX - textCenterX) * view.scale;
      var localStartY = (drawY - textCenterY) * view.scale;
      var bgPadPx = Math.max(1.5 * this.pixelRatio, 0.7 * view.scale);
      ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
      ctx.fillRect(
        localStartX - bgPadPx,
        localStartY - bgPadPx,
        drawW * view.scale + bgPadPx * 2,
        drawH * view.scale + bgPadPx * 2
      );
      ctx.fillStyle = item.color || '#000000';
      for (var t = 0; t < linesText.length; t += 1) {
        var alignOffsetPx = 0;
        if (item.align === 'center') {
          alignOffsetPx = (drawW * view.scale - lineWidths[t]) / 2;
        } else if (item.align === 'right') {
          alignOffsetPx = (drawW * view.scale - lineWidths[t]);
        }
        ctx.fillText(linesText[t], localStartX + alignOffsetPx, localStartY + t * lineHeightPx);
      }
      ctx.restore();
    } else if (item.type === 'shape') {
      drawW = Math.max(0.2, item.wMm || 10);
      drawH = Math.max(0.2, item.hMm || 10);
      this.clampOverlayToPrintable(item, paper);
      drawX = item.xMm;
      drawY = item.yMm;
      this.drawShapeOverlay(ctx, view, item, drawX, drawY, drawW, drawH, rotationDeg);
      if (item.showCoordinates && this.isCircularShapeKind(item.shapeKind)) {
        var shapeCenterXmm = drawX + drawW / 2;
        var shapeCenterYmm = drawY + drawH / 2;
        var shapeCoordText = this.getRelativeCoordinateText(shapeCenterXmm, shapeCenterYmm);
        var shapeLabelYmm = clamp(
          shapeCenterYmm + Math.max(drawW, drawH) / 2 + 0.8,
          0,
          Math.max(0, paper.height - 1)
        );
        this.drawRelativeCoordinateBadge(ctx, view, shapeCenterXmm, shapeLabelYmm, shapeCoordText);
      }
    } else if (item.type === 'image' || item.type === 'logo') {
      var record = this.getOverlayImageRecord(item.srcDataUrl);
      if (record && record.status === 'ready' && record.image) {
        if (item.preserveAspect && record.image.width > 0) {
          item.hMm = item.wMm * (record.image.height / record.image.width);
        }
        drawW = Math.max(2, item.wMm);
        drawH = Math.max(2, item.hMm);
        if (!this.state.cutMoveUnlocked || item.type === 'logo') {
          this.clampOverlayToPrintable(item, paper);
        }
        drawX = item.xMm;
        drawY = item.yMm;
        var centerX = drawX + drawW / 2;
        var centerY = drawY + drawH / 2;
        var centerPx = this.paperToCanvas(centerX, centerY, view);
        var overlayVisualAlpha = item.type === 'logo' ? 1 : (this.sceneVisualAlpha || 1);
        ctx.save();
        ctx.globalAlpha = clamp(item.opacity, 0, 1) * overlayVisualAlpha;
        ctx.translate(centerPx.x, centerPx.y);
        ctx.rotate((rotationDeg * Math.PI) / 180);
        ctx.drawImage(
          record.image,
          (-drawW / 2) * view.scale,
          (-drawH / 2) * view.scale,
          drawW * view.scale,
          drawH * view.scale
        );
        ctx.restore();
      }
    }
    var computedXmm = drawX;
    var computedYmm = drawY;
    var computedWmm = drawW;
    var computedHmm = drawH;
    if (item.type === 'shape' && item.shapeKind === 'compass-marker') {
      // Compass marker renders as a triangle inset to 96% width and 78% height.
      // Keep interaction/selection bounds aligned to the visible triangle only.
      computedXmm = drawX + drawW * 0.02;
      computedYmm = drawY;
      computedWmm = drawW * 0.96;
      computedHmm = drawH * 0.78;
    }
    item._computedXmm = computedXmm;
    item._computedYmm = computedYmm;
    item._computedWmm = computedWmm;
    item._computedHmm = computedHmm;
    item._computedRotationDeg = rotationDeg;

    var aabb = this.getRotatedRectAabb(computedXmm, computedYmm, computedWmm, computedHmm, rotationDeg);
    this.hitRegions.push({
      kind: 'overlay',
      id: item.id,
      xMm: aabb.x,
      yMm: aabb.y,
      wMm: Math.max(2, aabb.w),
      hMm: Math.max(2, aabb.h),
      hitTest: 'rotated-rect',
      vertices: [
        { x: aabb.corners.tl.x, y: aabb.corners.tl.y },
        { x: aabb.corners.tr.x, y: aabb.corners.tr.y },
        { x: aabb.corners.br.x, y: aabb.corners.br.y },
        { x: aabb.corners.bl.x, y: aabb.corners.bl.y }
      ],
      z: 60 + item.zIndex
    });
  };

  ScaleBarBuilder.prototype.drawOverlayItems = function (ctx, view, paper, tags) {
    this.applyLogoAutoPlacement(paper, tags);

    var overlayItems = this.state.overlayItems.slice().sort(function (a, b) {
      return a.zIndex - b.zIndex;
    });

    for (var i = 0; i < overlayItems.length; i += 1) {
      this.drawOverlayItem(ctx, view, paper, overlayItems[i], tags);
    }
  };

  ScaleBarBuilder.prototype.drawSelectionAndMiniToolbar = function (ctx, view, tags) {
    if (!this.state.selectedEntity) {
      return;
    }

    var handleHitGraceMm = (8 * this.pixelRatio) / Math.max(0.0001, view.scale);

    ctx.save();
    ctx.strokeStyle = 'rgba(22, 101, 216, 0.95)';
    ctx.fillStyle = 'rgba(22, 101, 216, 0.08)';
    ctx.lineWidth = Math.max(1, 0.14 * view.scale);

    if (this.state.selectedEntity.type === 'tag') {
      var idx = this.state.selectedEntity.id;
      if (typeof idx === 'number' && tags[idx]) {
        var tag = tags[idx];
        var tagSizeMm = this.getTagSizeMm(idx);
        var topLeft = this.paperToCanvas(tag.xMm - tagSizeMm / 2, tag.yMm - tagSizeMm / 2, view);
        var sizePx = tagSizeMm * view.scale;
        ctx.fillRect(topLeft.x, topLeft.y, sizePx, sizePx);
        ctx.strokeRect(topLeft.x, topLeft.y, sizePx, sizePx);

        var buttonWmm = 11;
        var buttonHmm = 7;
        var yMm = tag.yMm - tagSizeMm / 2 - buttonHmm - 1.8;
        var leftXmm = tag.xMm - buttonWmm - 0.8;
        var rightXmm = tag.xMm + 0.8;

        this.drawMiniToolbarButton(ctx, view, leftXmm, yMm, buttonWmm, buttonHmm, 'Prev');
        this.drawMiniToolbarButton(ctx, view, rightXmm, yMm, buttonWmm, buttonHmm, 'Next');

        this.hitRegions.push({
          kind: 'tag-id-prev',
          index: idx,
          xMm: leftXmm,
          yMm: yMm,
          wMm: buttonWmm,
          hMm: buttonHmm,
          z: 95
        });

        this.hitRegions.push({
          kind: 'tag-id-next',
          index: idx,
          xMm: rightXmm,
          yMm: yMm,
          wMm: buttonWmm,
          hMm: buttonHmm,
          z: 95
        });

        var auxWmm = 13;
        var auxHmm = 7;
        var auxYmm = yMm - auxHmm - 1.2;
        var delXmm = tag.xMm - auxWmm - 3.2;
        var relXmm = tag.xMm + 3.2;

        this.drawMiniToolbarButton(ctx, view, delXmm, auxYmm, auxWmm, auxHmm, 'Bin');
        this.drawMiniToolbarButton(ctx, view, relXmm, auxYmm, auxWmm, auxHmm, 'Rel', this.state.showRelativeCoordinates);

        this.hitRegions.push({
          kind: 'tag-delete',
          index: idx,
          xMm: delXmm,
          yMm: auxYmm,
          wMm: auxWmm,
          hMm: auxHmm,
          z: 95
        });
        this.hitRegions.push({
          kind: 'tag-toggle-relative',
          index: idx,
          xMm: relXmm,
          yMm: auxYmm,
          wMm: auxWmm,
          hMm: auxHmm,
          z: 95
        });

        var corners = [
          { key: 'tl', x: tag.xMm - tagSizeMm / 2, y: tag.yMm - tagSizeMm / 2 },
          { key: 'tr', x: tag.xMm + tagSizeMm / 2, y: tag.yMm - tagSizeMm / 2 },
          { key: 'br', x: tag.xMm + tagSizeMm / 2, y: tag.yMm + tagSizeMm / 2 },
          { key: 'bl', x: tag.xMm - tagSizeMm / 2, y: tag.yMm + tagSizeMm / 2 }
        ];
        for (var tc = 0; tc < corners.length; tc += 1) {
          var corner = corners[tc];
          var cp = this.paperToCanvas(corner.x, corner.y, view);
          var cSizePx = Math.max(4, 1.4 * view.scale);
          var cSizeMm = (cSizePx * 2) / Math.max(0.0001, view.scale);
          ctx.fillStyle = 'rgba(22, 101, 216, 0.95)';
          ctx.fillRect(cp.x - cSizePx, cp.y - cSizePx, cSizePx * 2, cSizePx * 2);
          this.hitRegions.push({
            kind: 'tag-scale-corner',
            index: idx,
            corner: corner.key,
            xMm: corner.x - cSizeMm / 2 - handleHitGraceMm,
            yMm: corner.y - cSizeMm / 2 - handleHitGraceMm,
            wMm: cSizeMm + handleHitGraceMm * 2,
            hMm: cSizeMm + handleHitGraceMm * 2,
            z: 96
          });
        }

      }
    }

    if (this.state.selectedEntity.type === 'overlay') {
      var ov = this.findOverlayById(this.state.selectedEntity.id);
      if (ov) {
        var x = typeof ov._computedXmm === 'number' ? ov._computedXmm : ov.xMm;
        var y = typeof ov._computedYmm === 'number' ? ov._computedYmm : ov.yMm;
        var w = Math.max(2, ov._computedWmm || ov.wMm || 2);
        var h = Math.max(2, ov._computedHmm || ov.hMm || 2);
        var rot = this.normalizeRotation(ov._computedRotationDeg || ov.rotationDeg || 0);
        var cornersOv = this.getRotatedRectCorners(x, y, w, h, rot);
        var ptl = this.paperToCanvas(cornersOv.tl.x, cornersOv.tl.y, view);
        var ptr = this.paperToCanvas(cornersOv.tr.x, cornersOv.tr.y, view);
        var pbr = this.paperToCanvas(cornersOv.br.x, cornersOv.br.y, view);
        var pbl = this.paperToCanvas(cornersOv.bl.x, cornersOv.bl.y, view);
        ctx.beginPath();
        ctx.moveTo(ptl.x, ptl.y);
        ctx.lineTo(ptr.x, ptr.y);
        ctx.lineTo(pbr.x, pbr.y);
        ctx.lineTo(pbl.x, pbl.y);
        ctx.closePath();
        ctx.stroke();

        if (ov.type === 'text' || ov.type === 'image' || ov.type === 'logo' || ov.type === 'shape') {
          var cornerHandleMm = Math.max(2.2, Math.min(w, h) * 0.12);
          this.drawCornerHandle(ctx, view, cornersOv.tl, cornerHandleMm);
          this.drawCornerHandle(ctx, view, cornersOv.tr, cornerHandleMm);
          this.drawCornerHandle(ctx, view, cornersOv.br, cornerHandleMm);
          this.drawCornerHandle(ctx, view, cornersOv.bl, cornerHandleMm);
          this.hitRegions.push({ kind: 'overlay-scale-corner', id: ov.id, corner: 'tl', xMm: cornersOv.tl.x - cornerHandleMm / 2 - handleHitGraceMm, yMm: cornersOv.tl.y - cornerHandleMm / 2 - handleHitGraceMm, wMm: cornerHandleMm + handleHitGraceMm * 2, hMm: cornerHandleMm + handleHitGraceMm * 2, z: 97 });
          this.hitRegions.push({ kind: 'overlay-scale-corner', id: ov.id, corner: 'tr', xMm: cornersOv.tr.x - cornerHandleMm / 2 - handleHitGraceMm, yMm: cornersOv.tr.y - cornerHandleMm / 2 - handleHitGraceMm, wMm: cornerHandleMm + handleHitGraceMm * 2, hMm: cornerHandleMm + handleHitGraceMm * 2, z: 97 });
          this.hitRegions.push({ kind: 'overlay-scale-corner', id: ov.id, corner: 'br', xMm: cornersOv.br.x - cornerHandleMm / 2 - handleHitGraceMm, yMm: cornersOv.br.y - cornerHandleMm / 2 - handleHitGraceMm, wMm: cornerHandleMm + handleHitGraceMm * 2, hMm: cornerHandleMm + handleHitGraceMm * 2, z: 97 });
          this.hitRegions.push({ kind: 'overlay-scale-corner', id: ov.id, corner: 'bl', xMm: cornersOv.bl.x - cornerHandleMm / 2 - handleHitGraceMm, yMm: cornersOv.bl.y - cornerHandleMm / 2 - handleHitGraceMm, wMm: cornerHandleMm + handleHitGraceMm * 2, hMm: cornerHandleMm + handleHitGraceMm * 2, z: 97 });
        }

        if (ov.type === 'text' || ov.type === 'image' || ov.type === 'logo' || ov.type === 'shape') {
          var rotatePosOv = this.getRotateHandlePosition(cornersOv, 6);
          var rotateRadiusPxOv = Math.max(6, 2.1 * view.scale);
          var rotateRadiusMmOv = rotateRadiusPxOv / Math.max(0.0001, view.scale);
          var rotateHitRadiusMmOv = rotateRadiusMmOv + handleHitGraceMm;
          this.drawRotateHandle(ctx, view, rotatePosOv);
          this.hitRegions.push({
            kind: 'rotate-handle',
            entityType: 'overlay',
            id: ov.id,
            hitTest: 'circle',
            cxMm: rotatePosOv.x,
            cyMm: rotatePosOv.y,
            rMm: rotateHitRadiusMmOv,
            xMm: rotatePosOv.x - rotateHitRadiusMmOv,
            yMm: rotatePosOv.y - rotateHitRadiusMmOv,
            wMm: rotateHitRadiusMmOv * 2,
            hMm: rotateHitRadiusMmOv * 2,
            z: 98
          });
        }
      }
    }

    if (this.state.selectedEntity.type === 'reference') {
      var ref = this.getReferenceById(this.state.selectedEntity.id);
      if (ref) {
        var refWmm = Math.max(ref.cellWidthMm || 1, ref.lengthMm || 1);
        var refHmm = Math.max(ref.cellHeightMm || 1, 1) * Math.max(1, Math.round(ref.rows || 1));
        var refCorners = this.getRotatedRectCorners(ref.xMm, ref.yMm, refWmm, refHmm, this.normalizeRotation(ref.rotationDeg || 0));
        var rptl = this.paperToCanvas(refCorners.tl.x, refCorners.tl.y, view);
        var rptr = this.paperToCanvas(refCorners.tr.x, refCorners.tr.y, view);
        var rpbr = this.paperToCanvas(refCorners.br.x, refCorners.br.y, view);
        var rpbl = this.paperToCanvas(refCorners.bl.x, refCorners.bl.y, view);
        ctx.beginPath();
        ctx.moveTo(rptl.x, rptl.y);
        ctx.lineTo(rptr.x, rptr.y);
        ctx.lineTo(rpbr.x, rpbr.y);
        ctx.lineTo(rpbl.x, rpbl.y);
        ctx.closePath();
        ctx.stroke();

        var leftRefPt = this.rotatePoint(ref.xMm, ref.yMm + refHmm / 2, refCorners.cx, refCorners.cy, this.normalizeRotation(ref.rotationDeg || 0));
        var rightRefPt = this.rotatePoint(ref.xMm + refWmm, ref.yMm + refHmm / 2, refCorners.cx, refCorners.cy, this.normalizeRotation(ref.rotationDeg || 0));
        var topRefPt = this.rotatePoint(ref.xMm + refWmm / 2, ref.yMm, refCorners.cx, refCorners.cy, this.normalizeRotation(ref.rotationDeg || 0));
        var bottomRefPt = this.rotatePoint(ref.xMm + refWmm / 2, ref.yMm + refHmm, refCorners.cx, refCorners.cy, this.normalizeRotation(ref.rotationDeg || 0));
        var leftPx = this.paperToCanvas(leftRefPt.x, leftRefPt.y, view);
        var rightPx = this.paperToCanvas(rightRefPt.x, rightRefPt.y, view);
        var topPx = this.paperToCanvas(topRefPt.x, topRefPt.y, view);
        var bottomPx = this.paperToCanvas(bottomRefPt.x, bottomRefPt.y, view);
        var rr = Math.max(5 * this.pixelRatio, 5);
        var rrMm = rr / Math.max(0.0001, view.scale);
        ctx.fillStyle = 'rgba(22, 101, 216, 0.95)';
        ctx.beginPath();
        ctx.arc(leftPx.x, leftPx.y, rr, 0, Math.PI * 2);
        ctx.fill();
        ctx.beginPath();
        ctx.arc(rightPx.x, rightPx.y, rr, 0, Math.PI * 2);
        ctx.fill();
        var vHandlePx = Math.max(8 * this.pixelRatio, 8);
        ctx.fillRect(topPx.x - vHandlePx / 2, topPx.y - vHandlePx / 2, vHandlePx, vHandlePx);
        ctx.fillRect(bottomPx.x - vHandlePx / 2, bottomPx.y - vHandlePx / 2, vHandlePx, vHandlePx);

        this.hitRegions.push({
          kind: 'reference-handle-left',
          id: ref.id,
          hitTest: 'circle',
          cxMm: leftRefPt.x,
          cyMm: leftRefPt.y,
          rMm: rrMm + handleHitGraceMm,
          xMm: leftRefPt.x - (rrMm + handleHitGraceMm),
          yMm: leftRefPt.y - (rrMm + handleHitGraceMm),
          wMm: (rrMm + handleHitGraceMm) * 2,
          hMm: (rrMm + handleHitGraceMm) * 2,
          z: 99
        });
        this.hitRegions.push({
          kind: 'reference-handle-right',
          id: ref.id,
          hitTest: 'circle',
          cxMm: rightRefPt.x,
          cyMm: rightRefPt.y,
          rMm: rrMm + handleHitGraceMm,
          xMm: rightRefPt.x - (rrMm + handleHitGraceMm),
          yMm: rightRefPt.y - (rrMm + handleHitGraceMm),
          wMm: (rrMm + handleHitGraceMm) * 2,
          hMm: (rrMm + handleHitGraceMm) * 2,
          z: 99
        });
        var vHandleMm = vHandlePx / view.scale;
        var vHandleHitMm = vHandleMm + handleHitGraceMm * 2;
        this.hitRegions.push({
          kind: 'reference-handle-top',
          id: ref.id,
          xMm: topRefPt.x - vHandleHitMm / 2,
          yMm: topRefPt.y - vHandleHitMm / 2,
          wMm: vHandleHitMm,
          hMm: vHandleHitMm,
          z: 99
        });
        this.hitRegions.push({
          kind: 'reference-handle-bottom',
          id: ref.id,
          xMm: bottomRefPt.x - vHandleHitMm / 2,
          yMm: bottomRefPt.y - vHandleHitMm / 2,
          wMm: vHandleHitMm,
          hMm: vHandleHitMm,
          z: 99
        });

        var rotatePosRef = this.getRotateHandlePosition(refCorners, 6);
        var rotateRadiusPxRef = Math.max(6, 2.1 * view.scale);
        var rotateRadiusMmRef = rotateRadiusPxRef / Math.max(0.0001, view.scale);
        var rotateHitRadiusMmRef = rotateRadiusMmRef + handleHitGraceMm;
        this.drawRotateHandle(ctx, view, rotatePosRef);
        this.hitRegions.push({
          kind: 'rotate-handle',
          entityType: 'reference',
          id: ref.id,
          hitTest: 'circle',
          cxMm: rotatePosRef.x,
          cyMm: rotatePosRef.y,
          rMm: rotateHitRadiusMmRef,
          xMm: rotatePosRef.x - rotateHitRadiusMmRef,
          yMm: rotatePosRef.y - rotateHitRadiusMmRef,
          wMm: rotateHitRadiusMmRef * 2,
          hMm: rotateHitRadiusMmRef * 2,
          z: 98
        });
      }
    }

    if (this.state.selectedEntity.type === 'distance') {
      var cache = this.distanceRenderCache && this.distanceRenderCache[this.state.selectedEntity.id];
      if (cache) {
        var c = this.paperToCanvas(cache.labelXmm, cache.labelYmm, view);
        var sz = Math.max(6, 1.8 * view.scale);
        ctx.strokeStyle = 'rgba(22, 101, 216, 0.95)';
        ctx.strokeRect(c.x - sz, c.y - sz, sz * 2, sz * 2);
      }
    }

    if (this.state.selectedEntity.type === 'cut' && this.state.cutShape && this.state.cutShape.bbox) {
      var bb = this.state.cutShape.bbox;
      var topLeftCut = this.paperToCanvas(bb.xMm, bb.yMm, view);
      ctx.strokeStyle = 'rgba(22, 101, 216, 0.85)';
      ctx.lineWidth = Math.max(1, 0.12 * view.scale);
      ctx.strokeRect(topLeftCut.x, topLeftCut.y, bb.wMm * view.scale, bb.hMm * view.scale);
    }

    this.drawSelectionReadout(ctx, view, tags);
    ctx.restore();
  };

  ScaleBarBuilder.prototype.drawMiniToolbarButton = function (ctx, view, xMm, yMm, wMm, hMm, text, active) {
    var topLeft = this.paperToCanvas(xMm, yMm, view);
    ctx.fillStyle = active ? 'rgba(224, 240, 255, 0.97)' : 'rgba(255, 255, 255, 0.94)';
    ctx.strokeStyle = 'rgba(22, 101, 216, 0.95)';
    ctx.lineWidth = Math.max(1, 0.12 * view.scale);
    ctx.fillRect(topLeft.x, topLeft.y, wMm * view.scale, hMm * view.scale);
    ctx.strokeRect(topLeft.x, topLeft.y, wMm * view.scale, hMm * view.scale);
    ctx.fillStyle = 'rgba(22, 101, 216, 0.95)';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = Math.max(8, 2.7 * view.scale) + 'px "IBM Plex Sans", sans-serif';
    ctx.fillText(text, topLeft.x + (wMm * view.scale) / 2, topLeft.y + (hMm * view.scale) / 2 + this.pixelRatio * 0.15);
  };

  ScaleBarBuilder.prototype.drawCornerHandle = function (ctx, view, pointMm, sizeMm) {
    var p = this.paperToCanvas(pointMm.x, pointMm.y, view);
    var sizePx = sizeMm * view.scale;
    ctx.fillStyle = 'rgba(22, 101, 216, 0.95)';
    ctx.fillRect(p.x - sizePx / 2, p.y - sizePx / 2, sizePx, sizePx);
  };

  ScaleBarBuilder.prototype.getRotateHandlePosition = function (corners, offsetMm) {
    var centerX = corners.cx;
    var centerY = corners.cy;
    var tr = corners.tr;
    var dx = tr.x - centerX;
    var dy = tr.y - centerY;
    var len = Math.sqrt(dx * dx + dy * dy) || 1;
    var nx = dx / len;
    var ny = dy / len;
    return {
      x: tr.x + nx * offsetMm,
      y: tr.y + ny * offsetMm
    };
  };

  ScaleBarBuilder.prototype.drawRotateHandle = function (ctx, view, pointMm) {
    var p = this.paperToCanvas(pointMm.x, pointMm.y, view);
    var rPx = Math.max(6, 2.1 * view.scale);
    ctx.fillStyle = 'rgba(255,255,255,0.95)';
    ctx.strokeStyle = 'rgba(22,101,216,0.95)';
    ctx.lineWidth = Math.max(1, 0.12 * view.scale);
    ctx.beginPath();
    ctx.arc(p.x, p.y, rPx, 0, Math.PI * 2);
    ctx.fill();
    ctx.stroke();
    var innerRadiusPx = rPx * 0.56;
    var startAngle = 0.45 * Math.PI;
    var endAngle = 2.18 * Math.PI;
    ctx.strokeStyle = 'rgba(22,101,216,0.95)';
    ctx.lineWidth = Math.max(1, 0.12 * view.scale);
    ctx.beginPath();
    ctx.arc(p.x, p.y, innerRadiusPx, startAngle, endAngle, false);
    ctx.stroke();
    var arrowTipX = p.x + Math.cos(startAngle) * innerRadiusPx;
    var arrowTipY = p.y + Math.sin(startAngle) * innerRadiusPx;
    var tangentAngle = startAngle - Math.PI / 2;
    var arrowLenPx = Math.max(2.4, rPx * 0.44);
    ctx.fillStyle = 'rgba(22,101,216,0.95)';
    ctx.beginPath();
    ctx.moveTo(arrowTipX, arrowTipY);
    ctx.lineTo(
      arrowTipX - Math.cos(tangentAngle - 0.58) * arrowLenPx,
      arrowTipY - Math.sin(tangentAngle - 0.58) * arrowLenPx
    );
    ctx.lineTo(
      arrowTipX - Math.cos(tangentAngle + 0.58) * arrowLenPx,
      arrowTipY - Math.sin(tangentAngle + 0.58) * arrowLenPx
    );
    ctx.closePath();
    ctx.fill();
  };

  ScaleBarBuilder.prototype.drawReadoutBox = function (ctx, xPx, yPx, lines) {
    if (!lines || lines.length === 0) {
      return;
    }
    ctx.save();
    var readoutFontPx = this.scalePreviewPx(Math.max(9 * this.pixelRatio, 10));
    ctx.font = readoutFontPx + 'px "IBM Plex Mono", monospace';
    var maxWidth = 0;
    for (var i = 0; i < lines.length; i += 1) {
      maxWidth = Math.max(maxWidth, ctx.measureText(lines[i]).width);
    }
    var padX = this.scalePreviewPx(6 * this.pixelRatio);
    var padY = this.scalePreviewPx(5 * this.pixelRatio);
    var lineH = this.scalePreviewPx(12 * this.pixelRatio);
    var boxW = maxWidth + padX * 2;
    var boxH = lines.length * lineH + padY * 2;
    var edgePad = this.scalePreviewPx(4 * this.pixelRatio);
    var left = clamp(xPx, edgePad, Math.max(edgePad, this.canvas.width - boxW - edgePad));
    var top = clamp(yPx, edgePad, Math.max(edgePad, this.canvas.height - boxH - edgePad));

    ctx.fillStyle = 'rgba(255, 255, 255, 0.94)';
    ctx.strokeStyle = 'rgba(22, 101, 216, 0.9)';
    ctx.lineWidth = Math.max(1, 0.1 * this.pixelRatio);
    ctx.fillRect(left, top, boxW, boxH);
    ctx.strokeRect(left, top, boxW, boxH);

    ctx.fillStyle = 'rgba(31, 41, 51, 0.95)';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    for (var j = 0; j < lines.length; j += 1) {
      ctx.fillText(lines[j], left + padX, top + padY + j * lineH);
    }
    ctx.restore();
  };

  ScaleBarBuilder.prototype.getReadoutAnchorFromCorners = function (corners, view, marginPx) {
    if (!corners || !view) {
      return null;
    }
    var mmPerPx = 1 / Math.max(0.0001, view.scale);
    var marginMm = Math.max(1.2, (marginPx || 18) * mmPerPx);
    var minX = Infinity;
    var maxX = -Infinity;
    var minY = Infinity;
    var maxY = -Infinity;
    var key;
    for (key in corners) {
      if (!Object.prototype.hasOwnProperty.call(corners, key)) {
        continue;
      }
      minX = Math.min(minX, corners[key].x);
      maxX = Math.max(maxX, corners[key].x);
      minY = Math.min(minY, corners[key].y);
      maxY = Math.max(maxY, corners[key].y);
    }
    if (!isFinite(minX) || !isFinite(maxX) || !isFinite(minY) || !isFinite(maxY)) {
      return null;
    }
    var anchorX = maxX + marginMm;
    var anchorY = (minY + maxY) / 2;

    var paper = this.getPaper();
    if (paper) {
      var printable = this.getPrintableRect(paper, 0);
      if (anchorX > printable.maxX - marginMm * 0.2) {
        anchorX = minX - marginMm * 2.2;
      }
      anchorX = clamp(anchorX, printable.minX, printable.maxX);
      anchorY = clamp(anchorY, printable.minY, printable.maxY);
    }

    return { x: anchorX, y: anchorY };
  };

  ScaleBarBuilder.prototype.drawSelectionReadout = function (ctx, view, tags) {
    if (!this.state.selectedEntity) {
      return;
    }

    var lines = [];
    var anchorX = 0;
    var anchorY = 0;

    if (this.state.selectedEntity.type === 'tag') {
      var index = this.state.selectedEntity.id;
      var tag = tags[index];
      if (!tag) {
        return;
      }
      var relOrigin = this.getHomePoint();
      lines.push(this.getTagDisplayCode(tag.id));
      if (relOrigin) {
        lines.push('X ' + this.formatSignedDistanceMm(tag.xMm - relOrigin.xMm) + '  Y ' + this.formatSignedDistanceMm(tag.yMm - relOrigin.yMm));
      } else {
        lines.push('X ' + this.formatSignedDistanceMm(tag.xMm) + '  Y ' + this.formatSignedDistanceMm(tag.yMm));
      }
      var tSize = this.getTagSizeMm(index);
      var pTag = this.paperToCanvas(tag.xMm + tSize / 2 + 6, tag.yMm + tSize / 2 + 3, view);
      anchorX = pTag.x;
      anchorY = pTag.y;
    } else if (this.state.selectedEntity.type === 'overlay') {
      var ov = this.findOverlayById(this.state.selectedEntity.id);
      if (!ov) {
        return;
      }
      var x = typeof ov._computedXmm === 'number' ? ov._computedXmm : ov.xMm;
      var y = typeof ov._computedYmm === 'number' ? ov._computedYmm : ov.yMm;
      var w = Math.max(2, ov._computedWmm || ov.wMm || 2);
      var h = Math.max(2, ov._computedHmm || ov.hMm || 2);
      var rot = this.normalizeRotation(ov._computedRotationDeg || ov.rotationDeg || 0);
      var ovCorners = this.getRotatedRectCorners(x, y, w, h, rot);
      var ovReadoutMm = this.getReadoutAnchorFromCorners(ovCorners, view, 20) || this.getRotateHandlePosition(ovCorners, 14);
      lines.push('Overlay: ' + ov.type);
      lines.push('W ' + this.formatDistanceMm(w) + '  H ' + this.formatDistanceMm(h));
      lines.push('Rot ' + String(Math.round(rot)) + ' deg');
      var pOv = this.paperToCanvas(ovReadoutMm.x, ovReadoutMm.y, view);
      anchorX = pOv.x;
      anchorY = pOv.y;
    } else if (this.state.selectedEntity.type === 'reference') {
      var ref = this.getReferenceById(this.state.selectedEntity.id);
      if (!ref) {
        return;
      }
      var refWmm = Math.max(ref.cellWidthMm || 1, ref.lengthMm || 1);
      var refHmm = Math.max(0.2, ref.cellHeightMm || 1) * Math.max(1, Math.round(ref.rows || 1));
      var refRot = this.normalizeRotation(ref.rotationDeg || 0);
      var refCorners = this.getRotatedRectCorners(ref.xMm, ref.yMm, refWmm, refHmm, refRot);
      var refReadoutMm = this.getReadoutAnchorFromCorners(refCorners, view, 24) || this.getRotateHandlePosition(refCorners, 14);
      lines.push('Reference');
      lines.push('Len ' + this.formatDistanceMm(refWmm) + '  Rows ' + String(Math.max(1, Math.round(ref.rows || 1))));
      lines.push('Rot ' + String(Math.round(refRot)) + ' deg');
      var pRef = this.paperToCanvas(refReadoutMm.x, refReadoutMm.y, view);
      anchorX = pRef.x;
      anchorY = pRef.y;
    } else if (this.state.selectedEntity.type === 'distance') {
      var info = this.distanceRenderCache && this.distanceRenderCache[this.state.selectedEntity.id];
      if (!info) {
        return;
      }
      lines.push('Distance');
      lines.push('Tag ' + (info.aIndex + 1) + ' <-> Tag ' + (info.bIndex + 1));
      lines.push(this.formatDistanceMm(info.distanceMm));
      var rightX = info.lineStartXmm > info.lineEndXmm ? info.lineStartXmm : info.lineEndXmm;
      var rightY = info.lineStartXmm > info.lineEndXmm ? info.lineStartYmm : info.lineEndYmm;
      var pDist = this.paperToCanvas(rightX + 8, rightY - 4, view);
      anchorX = pDist.x;
      anchorY = pDist.y;
    } else {
      return;
    }

    this.drawReadoutBox(ctx, anchorX, anchorY, lines);
  };

  ScaleBarBuilder.prototype.getReferenceUnitSystem = function (ref) {
    var candidate = ref && ref.unitSystem ? ref.unitSystem : this.state.unitSystem;
    return String(candidate || 'metric') === 'imperial' ? 'imperial' : 'metric';
  };

  ScaleBarBuilder.prototype.getReferenceUnitLabel = function (unitSystem, longForm) {
    var normalized = String(unitSystem || 'metric') === 'imperial' ? 'imperial' : 'metric';
    if (normalized === 'imperial') {
      return longForm ? 'INCH' : 'in';
    }
    return longForm ? 'CM' : 'cm';
  };

  ScaleBarBuilder.prototype.formatReferenceAxisUnitLabel = function (sizeMm, unitSystem, options) {
    var opts = options || {};
    var compact = !!opts.compact;
    var useImperialWord = opts.useImperialWord !== false;
    var upperCaseUnit = !!opts.upperCaseUnit;
    var omitOneForMm = !!opts.omitOneForMm;
    var mm = Math.max(0, parseNumber(sizeMm, 0));
    var normalized = String(unitSystem || this.state.unitSystem || 'metric') === 'imperial' ? 'imperial' : 'metric';
    var approx = function (a, b, tolerance) {
      return Math.abs(a - b) <= tolerance;
    };

    if (normalized === 'metric') {
      var mmTolerance = Math.max(0.005, mm * 0.003);
      if (approx(mm, 1, mmTolerance) && omitOneForMm) {
        return upperCaseUnit ? 'MM' : 'mm';
      }
      var useMm = mm < 10 || !approx(mm / MM_PER_CM, Math.round((mm / MM_PER_CM) * 100) / 100, 0.0008);
      if (useMm) {
        var mmValue = toFixedTrim(mm, mm < 10 ? 2 : 1);
        var mmUnit = upperCaseUnit ? 'MM' : 'mm';
        return compact ? (mmValue + mmUnit) : (mmValue + ' ' + mmUnit);
      }
      var cmValue = toFixedTrim(mm / MM_PER_CM, 2);
      var cmUnit = upperCaseUnit ? 'CM' : 'cm';
      return compact ? (cmValue + cmUnit) : (cmValue + ' ' + cmUnit);
    }

    var inches = mm / MM_PER_IN;
    var roundedSixteenth = Math.round(inches * 16);
    var snapInches = roundedSixteenth / 16;
    var inchValueText = '';
    if (approx(inches, snapInches, 0.0055)) {
      var whole = Math.floor(roundedSixteenth / 16);
      var numerator = roundedSixteenth - whole * 16;
      if (numerator < 0) {
        numerator = 0;
      }
      if (numerator === 16) {
        whole += 1;
        numerator = 0;
      }
      if (numerator > 0) {
        var gcd = function (a, b) {
          var x = Math.abs(a);
          var y = Math.abs(b);
          while (y !== 0) {
            var t = x % y;
            x = y;
            y = t;
          }
          return x || 1;
        };
        var divisor = gcd(numerator, 16);
        numerator = numerator / divisor;
        var denominator = 16 / divisor;
        inchValueText = whole > 0 ? (String(whole) + ' ' + String(numerator) + '/' + String(denominator)) : (String(numerator) + '/' + String(denominator));
      } else {
        inchValueText = String(whole);
      }
    } else {
      inchValueText = toFixedTrim(inches, 3);
    }

    var inchUnit = useImperialWord
      ? (upperCaseUnit ? 'INCH' : 'inch')
      : (upperCaseUnit ? 'IN' : 'in');
    return compact ? (inchValueText + ' ' + inchUnit) : (inchValueText + ' ' + inchUnit);
  };

  ScaleBarBuilder.prototype.getReferenceSubdivisionCount = function (cellWidthMm, unitSystem) {
    var widthMm = Math.max(0.2, cellWidthMm);
    var minPrintableSubMm = 0.6;
    var maxByPrint = Math.max(2, Math.floor(widthMm / minPrintableSubMm));
    var refUnit = String(unitSystem || this.state.unitSystem || 'metric') === 'imperial' ? 'imperial' : 'metric';

    if (refUnit === 'metric') {
      var byMm = Math.max(2, Math.round(widthMm / 1));
      return clamp(Math.min(byMm, maxByPrint), 2, 20);
    }

    var eighthInchMm = MM_PER_IN / 8;
    var byEighth = Math.max(2, Math.round(widthMm / eighthInchMm));
    return clamp(Math.min(byEighth, maxByPrint), 2, 16);
  };

  ScaleBarBuilder.prototype.formatReferenceScaleValue = function (distanceMm, unitSystem) {
    var refUnit = String(unitSystem || this.state.unitSystem || 'metric') === 'imperial' ? 'imperial' : 'metric';
    if (refUnit === 'imperial') {
      return toFixedTrim(distanceMm / MM_PER_IN, 2);
    }
    return toFixedTrim(distanceMm / MM_PER_CM, 2);
  };

  ScaleBarBuilder.prototype.formatReferenceDistance = function (distanceMm, unitSystem) {
    var refUnit = String(unitSystem || this.state.unitSystem || 'metric') === 'imperial' ? 'imperial' : 'metric';
    if (refUnit === 'imperial') {
      return toFixedTrim(distanceMm / MM_PER_IN, 2) + ' in';
    }
    return toFixedTrim(distanceMm / MM_PER_CM, 2) + ' cm';
  };

  ScaleBarBuilder.prototype.formatReferenceMeasurementText = function (cellWidthMm, cellHeightMm, unitSystem) {
    var refUnit = String(unitSystem || this.state.unitSystem || 'metric') === 'imperial' ? 'imperial' : 'metric';
    var widthText = this.formatReferenceAxisUnitLabel(cellWidthMm, refUnit, {
      compact: false,
      useImperialWord: true,
      omitOneForMm: false
    });
    var heightText = this.formatReferenceAxisUnitLabel(cellHeightMm, refUnit, {
      compact: false,
      useImperialWord: true,
      omitOneForMm: false
    });
    return widthText + ' x ' + heightText;
  };

  ScaleBarBuilder.prototype.wrapTextLineToWidth = function (ctx, line, maxWidthPx) {
    var text = String(line || '');
    var widthPx = Math.max(1, parseNumber(maxWidthPx, 1));
    if (!text) {
      return [''];
    }
    if (ctx.measureText(text).width <= widthPx) {
      return [text];
    }

    var result = [];
    var words = text.split(/\s+/);
    var current = '';

    var pushBrokenWord = function (word) {
      var rest = String(word || '');
      while (rest.length > 0) {
        var part = '';
        for (var c = 0; c < rest.length; c += 1) {
          var candidate = part + rest.charAt(c);
          if (!part || ctx.measureText(candidate).width <= widthPx) {
            part = candidate;
          } else {
            break;
          }
        }
        if (!part) {
          break;
        }
        result.push(part);
        rest = rest.slice(part.length);
      }
    };

    for (var i = 0; i < words.length; i += 1) {
      var word = words[i];
      if (!word) {
        continue;
      }
      var candidateLine = current ? (current + ' ' + word) : word;
      if (ctx.measureText(candidateLine).width <= widthPx) {
        current = candidateLine;
        continue;
      }
      if (current) {
        result.push(current);
        current = '';
      }
      if (ctx.measureText(word).width <= widthPx) {
        current = word;
      } else {
        pushBrokenWord(word);
      }
    }

    if (current) {
      result.push(current);
    }
    return result.length ? result : [''];
  };

  ScaleBarBuilder.prototype.layoutTextLinesForOverlay = function (ctx, text, maxWidthPx) {
    var paragraphs = String(text || '').split(/\r?\n/);
    var wrapped = [];
    for (var i = 0; i < paragraphs.length; i += 1) {
      var parts = this.wrapTextLineToWidth(ctx, paragraphs[i], maxWidthPx);
      for (var j = 0; j < parts.length; j += 1) {
        wrapped.push(parts[j]);
      }
    }
    if (!wrapped.length) {
      wrapped.push('');
    }
    return wrapped;
  };

  ScaleBarBuilder.prototype.isReferenceRowStyle = function (style) {
    var mode = style || 'checker';
    return mode === 'checker' || mode === 'checker-invert' || mode === 'segmented-blocks';
  };

})();
